<template lang="pug">
  #confirm-changes
    .mt-3
      template(v-if="init_loading === true")
        loading(:height="200")
      template(v-else)
        b-card.mt-1(header-tag="header")
          h4.mx-2.mt-1.mb-4.text-center.border.message-border-style.border-primary.rounded.p-3 入力内容をご確認ください。
          //- エラーメッセージ表示用
          app-messages(:errorMessages="order_errors")
          b-container(fluid="fluid")
            b-row
              b-col
                //- プラン
                template(v-if="plan_info.name !== ''")
                  b-row
                    b-col
                      b-row.align-items-center(:class="plan_service_title_class")
                        h5.font-weight-bold.mr-2.mb-0 {{ getPlanName(plan_info.name) }}
                        .mr-3
                          img.logo_desknets(src="@/assets/images/logo_desknetsneo_clear_background.png")
                        .mr-3(v-if="isContainAppSuiteInPlan(plan_info.name)")
                          img.logo_appsuite(src="@/assets/images/logo_appsuite.png")
                        .mr-3(v-if="isContainChatLuckInPlan(plan_info.name)")
                          img.logo_chatluck(src="@/assets/images/logo_chatluck.png")
                        b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('plan')") 修正
                      template(v-if="isChangeOrder(plan_info.name)")
                        b-form-text.change-label-before(:class="plan_service_data_class")
                          span {{ plan_info.user }}ユーザー
                          template(v-if="getDiffUser(plan_info.name) > 0")
                            span.text-success （+{{getDiffUser(plan_info.name)}}ユーザー）
                          template(v-else-if="getDiffUser(plan_info.name) < 0")
                            span.text-info （{{getDiffUser(plan_info.name)}}ユーザー）
                      template(v-else)
                        b-form-text.none-label-before(:class="plan_service_data_class")
                          span {{ plan_info.user }}ユーザー
                  b-form-text(style="height: 30px;")

                template(v-if="hasNeoOption()")
                  h4.font-weight-bold desknet's NEO ご利用オプションサービス
                  //- AppSuite
                  template(v-if="hasOrder('neo.app_suite_user') === true")
                    h5(:class="neo_service_title_class") 業務アプリ作成ツール AppSuite
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('option_service')") 修正
                    template(v-if="isNewOrder('neo.app_suite_user')")
                      b-form-text.new-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.app_suite_user }}ユーザー
                    template(v-else-if="isChangeOrder('neo.app_suite_user')")
                      b-form-text.change-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.app_suite_user }}ユーザー
                        template(v-if="getDiffUser('neo.app_suite_user') > 0")
                          span.text-success （+{{getDiffUser('neo.app_suite_user')}}ユーザー）
                        template(v-else-if="getDiffUser('neo.app_suite_user') < 0")
                          span.text-info （{{getDiffUser('neo.app_suite_user')}}ユーザー）
                    template(v-else-if="isCancelOrder('neo.app_suite_user')")
                      b-form-text.cancel-label-before(:class="neo_service_data_class")
                    template(v-else)
                      b-form-text.none-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.app_suite_user }}ユーザー
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                  //- 旧AppSuite
                  template(v-if="hasOrder('neo.app_suite_user_old') === true")
                    h5(:class="neo_service_title_class") 業務アプリ作成ツール AppSuite
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('option_service')") 修正
                    template(v-if="isNewOrder('neo.app_suite_user_old')")
                      b-form-text.new-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.app_suite_user_old }}ユーザー
                    template(v-else-if="isChangeOrder('neo.app_suite_user_old')")
                      b-form-text.change-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.app_suite_user_old }}ユーザー
                        template(v-if="getDiffUser('neo.app_suite_user_old') > 0")
                          span.text-success （+{{getDiffUser('neo.app_suite_user_old')}}ユーザー）
                        template(v-else-if="getDiffUser('neo.app_suite_user_old') < 0")
                          span.text-info （{{getDiffUser('neo.app_suite_user_old')}}ユーザー）
                    template(v-else-if="isCancelOrder('neo.app_suite_user_old')")
                      b-form-text.cancel-label-before(:class="neo_service_data_class")
                    template(v-else)
                      b-form-text.none-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.app_suite_user_old }}ユーザー
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                  //- ウェブ会議
                  template(v-if="hasOrder('neo.web_conferencing') === true")
                    h5(:class="neo_service_title_class") desknet's NEO ウェブ会議
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('option_service')") 修正
                    template(v-if="isNewOrder('neo.web_conferencing')")
                      b-form-text.new-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.web_conferencing }}会議室
                    template(v-else-if="isChangeOrder('neo.web_conferencing')")
                      b-form-text.change-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.web_conferencing }}会議室
                        template(v-if="getDiffUser('neo.web_conferencing') > 0")
                          span.text-success （+{{getDiffUser('neo.web_conferencing')}}会議室）
                        template(v-else-if="getDiffUser('neo.web_conferencing') < 0")
                          span.text-info （{{getDiffUser('neo.web_conferencing')}}会議室）
                    template(v-else-if="isCancelOrder('neo.web_conferencing')")
                      b-form-text.cancel-label-before(:class="neo_service_data_class")
                    template(v-else)
                      b-form-text.none-label-before(:class="neo_service_data_class")
                        span {{ display_order_info.neo.web_conferencing }}会議室
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                  //- desknet's DB
                  template(v-if="hasOrder('neo.cloud_db_user') === true")
                    h5(:class="neo_service_title_class") desknet's DB
                    b-form-text.none-label-before(:class="neo_service_data_class")
                      span {{ display_order_info.neo.cloud_db_user }}ユーザー
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                  //- オプションサービス
                  template(v-if="hasNeoOptionService() === true")
                    h5(:class="neo_service_title_class") オプションサービス
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('neo_option_service')") 修正
                    //- RoomMgr
                    template(v-if="hasOrder('neo.option.room_mgr') === true")
                      template(v-if="isNewOrder('neo.option.room_mgr')")
                        b-form-text.new-label-before(:class="neo_service_data_class") RoomMgr： 利用する
                      template(v-else-if="isCancelOrder('neo.option.room_mgr')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") RoomMgr
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") RoomMgr： 利用する
                    //- 交通費・経費精算
                    template(v-if="hasOrder('neo.option.expense_settlement') === true")
                      template(v-if="isNewOrder('neo.option.expense_settlement')")
                        b-form-text.new-label-before(:class="neo_service_data_class") 交通費経費精算： 利用する
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ※desknet's NEOのご契約ユーザー数と同数でのご契約となります。
                      template(v-else-if="isCancelOrder('neo.option.expense_settlement')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") 交通費経費精算
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") 交通費経費精算： 利用する
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ※desknet's NEOのご契約ユーザー数と同数でのご契約となります。
                    //- タイムカード + CLOUZA
                    template(v-if="hasOrder('neo.option.clouza') === true")
                      template(v-if="isNewOrder('neo.option.clouza')")
                        b-form-text.new-label-before(:class="neo_service_data_class") タイムカード＋CLOUZA
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザー数：{{ display_order_info.neo.option.clouza.user || '' }}
                              b-form-text.text-left 会社コード：{{ display_order_info.neo.option.clouza.clouza_company || '' }}
                              template(v-if="display_order_info.neo.option.clouza.paid_leave_option === true")
                                b-form-text.text-left.mb-2 有休管理＋申請承認オプション
                      template(v-else-if="isChangeOrder('neo.option.clouza')")
                        b-form-text.change-label-before(:class="neo_service_data_class") タイムカード＋CLOUZA
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span ユーザー数：{{ display_order_info.neo.option.clouza.user || '' }}ユーザー
                                template(v-if="getDiffUser('neo.option.clouza') > 0")
                                  span.text-success （+{{getDiffUser('neo.option.clouza')}}ユーザー）
                                template(v-else-if="getDiffUser('neo.option.clouza') < 0")
                                  span.text-info （{{getDiffUser('neo.option.clouza')}}ユーザー）
                              b-form-text.text-left
                                span 会社コード：{{ display_order_info.neo.option.clouza.clouza_company || '' }}
                              template(v-if="display_order_info.neo.option.clouza.paid_leave_option === true")
                                b-form-text.text-left.mb-2 有休管理＋申請承認オプション
                      template(v-else-if="isCancelOrder('neo.option.clouza')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") タイムカード＋CLOUZA
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") タイムカード＋CLOUZA
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザー数：{{ display_order_info.neo.option.clouza.user || '' }}
                              b-form-text.text-left 会社コード：{{ display_order_info.neo.option.clouza.clouza_company || '' }}
                              template(v-if="display_order_info.neo.option.clouza.paid_leave_option === true")
                                b-form-text.text-left.mb-2 有休管理＋申請承認オプション
                    //- ディスク増設
                    template(v-if="hasOrder('neo.option.disk.disk_size') === true")
                      template(v-if="isNewOrder('neo.option.disk.disk_size')")
                        b-form-text.new-label-before(:class="neo_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_disk_size }}
                      template(v-else-if="isChangeOrder('neo.option.disk.disk_size')")
                        b-form-text.change-label-before(:class="neo_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_disk_size }}
                                template(v-if="getDiffUser('neo.option.disk.disk_size') > 0")
                                  span.text-success （+{{20 * getDiffUser('neo.option.disk.disk_size')}}GB）
                                template(v-else-if="getDiffUser('neo.option.disk.disk_size') < 0")
                                  span.text-info （{{20 * getDiffUser('neo.option.disk.disk_size')}}GB）
                      template(v-else-if="isCancelOrder('neo.option.disk.disk_size')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") ディスク増設
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_disk_size }}
                    //- 旧ディスク増設
                    template(v-if="hasOrder('neo.option.disk.disk_size_old') === true")
                      template(v-if="isNewOrder('neo.option.disk.disk_size_old')")
                        b-form-text.new-label-before(:class="neo_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_disk_size_old }}
                      template(v-else-if="isChangeOrder('neo.option.disk.disk_size_old')")
                        b-form-text.change-label-before(:class="neo_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_disk_size_old }}
                                template(v-if="getDiffUser('neo.option.disk.disk_size_old') > 0")
                                  span.text-success （+{{20 * getDiffUser('neo.option.disk.disk_size_old')}}GB）
                                template(v-else-if="getDiffUser('neo.option.disk.disk_size_old') < 0")
                                  span.text-info （{{20 * getDiffUser('neo.option.disk.disk_size_old')}}GB）
                      template(v-else-if="isCancelOrder('neo.option.disk.disk_size_old')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") ディスク増設
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_disk_size_old }}
                    //- Sync for smartphone
                    template(v-if="hasOrder('neo.option.sync') === true")
                      template(v-if="isNewOrder('neo.option.sync')")
                        b-form-text.new-label-before(:class="neo_service_data_class") Sync for smartphones
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_order_info.neo.option.sync.user }}ユーザー
                      template(v-else-if="isChangeOrder('neo.option.sync')")
                        b-form-text.change-label-before(:class="neo_service_data_class") Sync for smartphones
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_order_info.neo.option.sync.user }}ユーザー
                                template(v-if="getDiffUser('neo.option.sync') > 0")
                                  span.text-success （+{{ getDiffUser('neo.option.sync') }}ユーザー）
                                template(v-else-if="getDiffUser('neo.option.sync') < 0")
                                  span.text-info （{{ getDiffUser('neo.option.sync') }}ユーザー）
                      template(v-else-if="isCancelOrder('neo.option.sync')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") Sync for smartphones
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") Sync for smartphones
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_order_info.neo.option.sync.user }}ユーザー
                    //- desknet's ドライブ ディスク増設
                    template(v-if="hasOrder('neo.option.dn_drive') === true")
                      template(v-if="isNewOrder('neo.option.dn_drive')")
                        b-form-text.new-label-before(:class="neo_service_data_class") desknet'sドライブ ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_dn_drive_disk_size }}
                      template(v-else-if="isChangeOrder('neo.option.dn_drive')")
                        b-form-text.change-label-before(:class="neo_service_data_class") desknet'sドライブ ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_dn_drive_disk_size }}
                                template(v-if="getDiffUser('neo.option.dn_drive') > 0")
                                  span.text-success （+{{20 * getDiffUser('neo.option.dn_drive')}}GB）
                                template(v-else-if="getDiffUser('neo.option.dn_drive') < 0")
                                  span.text-info （{{20 * getDiffUser('neo.option.dn_drive')}}GB）
                      template(v-else-if="isCancelOrder('neo.option.dn_drive')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") desknet'sドライブ ディスク増設
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") desknet'sドライブ ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_dn_drive_disk_size }}
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                  //- セキュリティオプション
                  template(v-if="hasNeoSecurityOption()")
                    h5(:class="neo_service_title_class") セキュリティオプション
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('neo_security_option')") 修正
                    //- BASIC認証
                    template(v-if="hasOrder('neo.security.basic') === true")
                      template(v-if="isNewOrder('neo.security.basic')")
                        b-form-text.new-label-before(:class="neo_service_data_class") BASIC認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザーID ： {{ display_order_info.neo.security.basic.basic_id }}
                              b-form-text.text-left パスワード ： {{ display_order_info.neo.security.basic.basic_password }}
                              template(v-if="display_order_info.neo.security.basic.basic_except_ip")
                                b-form-text.text-left 認証を除外するIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.basic.basic_except_ip)") {{ip_addr}}
                      template(v-else-if="isChangeOrder('neo.security.basic')")
                        b-form-text.change-label-before(:class="neo_service_data_class") BASIC認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザーID ： {{ display_order_info.neo.security.basic.basic_id }}
                              b-form-text.text-left パスワード ： {{ display_order_info.neo.security.basic.basic_password }}
                              template(v-if="display_order_info.neo.security.basic.basic_except_ip")
                                b-form-text.text-left 認証を除外するIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.basic.basic_except_ip)") {{ip_addr}}
                      template(v-else-if="isCancelOrder('neo.security.basic')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") BASIC認証
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") BASIC認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザーID ： {{ display_order_info.neo.security.basic.basic_id }}
                              b-form-text.text-left パスワード ： {{ display_order_info.neo.security.basic.basic_password }}
                              template(v-if="display_order_info.neo.security.basic.basic_except_ip")
                                b-form-text.text-left 認証を除外するIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.basic.basic_except_ip)") {{ip_addr}}
                    //- 接続元IPアドレス制限
                    template(v-if="hasOrder('neo.security.connect_permit_ip') === true")
                      template(v-if="isNewOrder('neo.security.connect_permit_ip')")
                        b-form-text.new-label-before(:class="neo_service_data_class") 接続元IPアドレス制限
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 接続を許可するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.connect_permit_ip)") {{ip_addr}}
                      template(v-else-if="isChangeOrder('neo.security.connect_permit_ip')")
                        b-form-text.change-label-before(:class="neo_service_data_class") 接続元IPアドレス制限
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 接続を許可するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.connect_permit_ip)") {{ip_addr}}
                      template(v-else-if="isCancelOrder('neo.security.connect_permit_ip')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") 接続元IPアドレス制限
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") 接続元IPアドレス制限
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 接続を許可するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.connect_permit_ip)") {{ip_addr}}
                    //- クライアント認証
                    template(v-if="hasOrder('neo.security.client') === true")
                      template(v-if="isNewOrder('neo.security.client')")
                        b-form-text.new-label-before(:class="neo_service_data_class") クライアント認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span デバイス数 ： {{ display_order_info.neo.security.client.device }}デバイス
                              b-form-text.text-left 認証を除外するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.client.cert_except_ip)") {{ip_addr}}
                      template(v-else-if="isChangeOrder('neo.security.client')")
                        b-form-text.change-label-before(:class="neo_service_data_class") クライアント認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span デバイス数 ： {{ display_order_info.neo.security.client.device }}デバイス
                                  template(v-if="getDiffUser('neo.security.client') > 0")
                                    span.text-success （+{{ getDiffUser('neo.security.client') }}デバイス）
                                  template(v-else-if="getDiffUser('neo.security.client') < 0")
                                    span.text-info （{{ getDiffUser('neo.security.client') }}デバイス）
                              b-form-text.text-left 認証を除外するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.client.cert_except_ip)") {{ip_addr}}
                      template(v-else-if="isCancelOrder('neo.security.client')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") クライアント認証
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") クライアント認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left デバイス数 ： {{ display_order_info.neo.security.client.device }}デバイス
                              b-form-text.text-left 認証を除外するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.client.cert_except_ip)") {{ip_addr}}
                    //- セキュアブラウザ
                    template(v-if="hasOrder('neo.security.secure') === true")
                      template(v-if="isChangeOrder('neo.security.secure')")
                        b-form-text.change-label-before(:class="neo_service_data_class") セキュアブラウザ
                          b-row
                            b-col(cols="1")
                            b-col
                              template(v-if="display_order_info.neo.security.secure.secure_browser_terminal === '01'")
                                b-form-text.text-left 端末認証：なし
                                b-form-text.text-left ※desknet's NEOのご契約ユーザー数と同数でのご契約となります。
                              template(v-else-if="display_order_info.neo.security.secure.secure_browser_terminal === '02'")
                                b-form-text.text-left 端末認証：あり
                                template(v-if="display_order_info.neo.security.secure.secure_browser_certificate_action === '01'")
                                  b-form-text.text-left デバイス数 ： {{ display_order_info.neo.security.secure.secure_browser_device }}デバイス
                                    template(v-if="getDiffUser('neo.security.secure') > 0")
                                      span.text-success （+{{ getDiffUser('neo.security.secure') }}デバイス）
                                    template(v-else-if="getDiffUser('neo.security.secure') < 0")
                                      span.text-info （{{ getDiffUser('neo.security.secure') }}デバイス）
                                template(v-else-if="display_order_info.neo.security.secure.secure_browser_certificate_action === '02'")
                                  b-form-text.text-left 再発行する証明書：
                                  b-form-text.text-left.ml-1 {{ display_order_info.neo.security.secure.secure_browser_re_create }}
                                template(v-else-if="display_order_info.neo.security.secure.secure_browser_certificate_action === '03'")
                                  b-form-text.text-left 削減する証明書：
                                  b-form-text.text-left.ml-1 {{ display_order_info.neo.security.secure.secure_browser_delete_certificate }}
                              template(v-if="display_order_info.neo.security.secure.secure_except_ip")
                                b-form-text.text-left セキュアブラウザを適用しないIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.secure.secure_except_ip)") {{ip_addr}}
                      template(v-else-if="isCancelOrder('neo.security.secure')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") セキュアブラウザ
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") セキュアブラウザ
                          b-row
                            b-col(cols="1")
                            b-col
                              template(v-if="display_order_info.neo.security.secure.secure_browser_terminal === '01'")
                                b-form-text.text-left 端末認証：なし
                                b-form-text.text-left ※desknet's NEOのご契約ユーザー数と同数でのご契約となります。
                              template(v-else-if="display_order_info.neo.security.secure.secure_browser_terminal === '02'")
                                b-form-text.text-left 端末認証：あり
                                b-form-text.text-left デバイス数 ： {{ display_order_info.neo.security.secure.secure_browser_device }}デバイス
                              template(v-if="display_order_info.neo.security.secure.secure_except_ip")
                                b-form-text.text-left セキュアブラウザを適用しないIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.neo.security.secure.secure_except_ip)") {{ip_addr}}
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                  //- メールサービス
                  template(v-if="hasNeoMailService()")
                    h5(:class="neo_service_title_class") メールサービス
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('neo_mail_service')") 修正
                    //- Web ARENA
                    template(v-if="hasOrder('neo.mail.arena') === true")
                      template(v-if="isNewOrder('neo.mail.arena')")
                        b-form-text.new-label-before(:class="neo_service_data_class") WebARENA
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 利用ドメイン名 ： {{ display_order_info.neo.mail.arena.wa_domain }}
                              b-form-text.text-left アカウント数 ： {{ display_order_info.neo.mail.arena.account }}アカウント
                      template(v-else-if="isChangeOrder('neo.mail.arena')")
                        b-form-text.change-label-before(:class="neo_service_data_class") WebARENA
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 利用ドメイン名 ： {{ display_order_info.neo.mail.arena.wa_domain }}
                              b-form-text.text-left アカウント数 ： {{ display_order_info.neo.mail.arena.account }}アカウント
                                template(v-if="getDiffUser('neo.mail.arena') > 0")
                                  span.text-success （+{{ getDiffUser('neo.mail.arena') }}アカウント）
                                template(v-else-if="getDiffUser('neo.mail.arena') < 0")
                                  span.text-info （{{ getDiffUser('neo.mail.arena') }}アカウント）
                      template(v-else-if="isCancelOrder('neo.mail.arena')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") WebARENA
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") WebARENA
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 利用ドメイン名 ： {{ display_order_info.neo.mail.arena.wa_domain }}
                              b-form-text.text-left アカウント数 ： {{ display_order_info.neo.mail.arena.account }}アカウント
                    //- CYBERMAILΣ
                    template(v-if="hasOrder('neo.mail.cyber') === true")
                      template(v-if="isNewOrder('neo.mail.cyber')")
                        b-form-text.new-label-before(:class="neo_service_data_class") CYBERMAILΣ
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left アカウント数 ： {{ display_order_info.neo.mail.cyber.account }}アカウント
                              b-form-text.text-left.mb-2 メールボックス容量 ： {{ cybermail_mailbox_size }}GB
                              b-form-text.font-weight-bold.text-left.mb-1 オプション
                              template(v-if="has_cyber_option_misdelivery_and_attached_encoding")
                                b-form-text.text-left ・情報漏えい対策(有償)を利用する
                              template(v-if="has_cyber_option_misdelivery_measure")
                                b-form-text.text-left ・添付ファイル暗号化・分離(有償)を利用する
                              template(v-if="has_cyber_option_archive")
                                b-form-text.text-left ・メールアーカイブ＆監査(有償)を利用する
                                b-form-text.text-left.ml-3 （ {{ cybermail_keep }}年保存 ）
                              template(v-if="has_cyber_option_sandbox")
                                b-form-text.text-left.mb-2 ・クラウド型サンドボックス(有償)を利用する
                      template(v-else-if="isChangeOrder('neo.mail.cyber')")
                        b-form-text.change-label-before(:class="neo_service_data_class") CYBERMAILΣ
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left アカウント数 ： {{ display_order_info.neo.mail.cyber.account }}アカウント
                                template(v-if="getDiffUser('neo.mail.cyber') > 0")
                                  span.text-success （+{{ getDiffUser('neo.mail.cyber') }}アカウント）
                                template(v-else-if="getDiffUser('neo.mail.cyber') < 0")
                                  span.text-info （{{ getDiffUser('neo.mail.cyber') }}アカウント）
                              b-form-text.text-left.mb-2 メールボックス容量 ： {{ cybermail_mailbox_size }}GB
                              b-form-text.font-weight-bold.text-left.mb-1 オプション
                              template(v-if="has_cyber_option_misdelivery_and_attached_encoding")
                                b-form-text.text-left ・情報漏えい対策(有償)を利用する
                              template(v-if="has_cyber_option_misdelivery_measure")
                                b-form-text.text-left ・添付ファイル暗号化・分離(有償)を利用する
                              template(v-if="has_cyber_option_archive")
                                b-form-text.text-left ・メールアーカイブ＆監査(有償)を利用する
                                b-form-text.text-left.ml-3 （ {{ cybermail_keep }}年保存 ）
                              template(v-if="has_cyber_option_sandbox")
                                b-form-text.text-left.mb-2 ・クラウド型サンドボックス(有償)を利用する
                      template(v-else-if="isCancelOrder('neo.mail.cyber')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") CYBERMAILΣ
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") CYBERMAILΣ
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left アカウント数 ： {{ display_order_info.neo.mail.cyber.account }}アカウント
                              b-form-text.text-left.mb-2 メールボックス容量 ： {{ cybermail_mailbox_size }}GB
                              b-form-text.font-weight-bold.text-left.mb-1 オプション
                              template(v-if="has_cyber_option_misdelivery_and_attached_encoding")
                                b-form-text.text-left ・情報漏えい対策(有償)を利用する
                              template(v-if="has_cyber_option_misdelivery_measure")
                                b-form-text.text-left ・添付ファイル暗号化・分離(有償)を利用する
                              template(v-if="has_cyber_option_archive")
                                b-form-text.text-left ・メールアーカイブ＆監査(有償)を利用する
                                b-form-text.text-left.ml-3 （ {{ cybermail_keep }}年保存 ）
                              template(v-if="has_cyber_option_sandbox")
                                b-form-text.text-left ・クラウド型サンドボックス(有償)を利用する
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                  //- メールセキュリティサービス
                  template(v-if="hasNeoMailSecurityService()")
                    h5(:class="neo_service_title_class") メールセキュリティサービス
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('neo_mail_security_service')") 修正
                    //- MAILGATESΣ
                    template(v-if="hasOrder('neo.mail_security.mailgates') === true")
                      template(v-if="isNewOrder('neo.mail_security.mailgates')")
                        b-form-text.new-label-before(:class="neo_service_data_class") MAILGATES Σ
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 利用ドメイン名 ： {{ display_order_info.neo.mail_security.mailgates.mailgates_domain }}
                              b-form-text.text-left.mb-2 アカウント数 ： {{ display_order_info.neo.mail_security.mailgates.account }}アカウント
                              b-form-text.font-weight-bold.text-left.mb-1 オプション
                              template(v-if="has_mailgates_option_antivirus_sandbox")
                                b-form-text.text-left ・アンチウイルス・スパム＋サンドボックス(有償)を利用する
                              template(v-if="has_mailgates_option_prevent_missend")
                                b-form-text.text-left ・誤送信対策・審査(有償)を利用する
                              template(v-if="has_mailgates_option_separation")
                                b-form-text.text-left ・添付ファイル暗号化・分離(有償)を利用する
                      template(v-else-if="isChangeOrder('neo.mail_security.mailgates')")
                        b-form-text.change-label-before(:class="neo_service_data_class") MAILGATES Σ
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 利用ドメイン名 ： {{ display_order_info.neo.mail_security.mailgates.mailgates_domain }}
                              b-form-text.text-left アカウント数 ： {{ display_order_info.neo.mail_security.mailgates.account }}アカウント
                                template(v-if="getDiffUser('neo.mail_security.mailgates') > 0")
                                  span.text-success （+{{ getDiffUser('neo.mail_security.mailgates') }}アカウント）
                                template(v-else-if="getDiffUser('neo.mail_security.mailgates') < 0")
                                  span.text-info （{{ getDiffUser('neo.mail_security.mailgates') }}アカウント）
                              b-form-text.font-weight-bold.text-left.mb-1 オプション
                              template(v-if="has_mailgates_option_antivirus_sandbox")
                                b-form-text.text-left ・アンチウイルス・スパム＋サンドボックス(有償)を利用する
                              template(v-if="has_mailgates_option_prevent_missend")
                                b-form-text.text-left ・誤送信対策・審査(有償)を利用する
                              template(v-if="has_mailgates_option_separation")
                                b-form-text.text-left ・添付ファイル暗号化・分離(有償)を利用する
                      template(v-else-if="isCancelOrder('neo.mail_security.mailgates')")
                        b-form-text.cancel-label-before(:class="neo_service_data_class") MAILGATES Σ
                      template(v-else)
                        b-form-text.none-label-before(:class="neo_service_data_class") MAILGATES Σ
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 利用ドメイン名 ： {{ display_order_info.neo.mail_security.mailgates.mailgates_domain }}
                              b-form-text.text-left.mb-2 アカウント数 ： {{ display_order_info.neo.mail_security.mailgates.account }}アカウント
                              b-form-text.font-weight-bold.text-left.mb-1 オプション
                              template(v-if="has_mailgates_option_antivirus_sandbox")
                                b-form-text.text-left ・アンチウイルス・スパム＋サンドボックス(有償)を利用する
                              template(v-if="has_mailgates_option_prevent_missend")
                                b-form-text.text-left ・誤送信対策・審査(有償)を利用する
                              template(v-if="has_mailgates_option_separation")
                                b-form-text.text-left ・添付ファイル暗号化・分離(有償)を利用する
                    b-form-text(:class="neo_service_data_class")
                    b-form-text(style="height: 30px;")

                //- ビジネスチャット ChatLuck
                template(v-if="hasOrder('chat.chat_user') === true")
                  h5(:class="chat_service_title_class") ビジネスチャット ChatLuck
                    b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('chat')") 修正
                  template(v-if="isChangeOrder('chat.chat_user')")
                    b-form-text.change-label-before(:class="chat_service_data_class")
                      span {{ display_order_info.chat.chat_user }} ユーザー
                      template(v-if="getDiffUser('chat.chat_user') > 0")
                        span.text-success （+{{getDiffUser('chat.chat_user')}}ユーザー）
                      template(v-else-if="getDiffUser('chat.chat_user') < 0")
                        span.text-info （{{getDiffUser('chat.chat_user')}}ユーザー）
                  template(v-else)
                    b-form-text.none-label-before(:class="chat_service_data_class")
                      span {{ display_order_info.chat.chat_user }} ユーザー
                  b-form-text(:class="chat_service_data_class")
                  b-form-text(style="height: 30px;")

                template(v-if="hasChatOption()")
                  h4.font-weight-bold ChatLuck ご利用オプションサービス
                  //- ChatLuckオプションサービス
                  template(v-if="hasChatOptionService()")
                    h5(:class="chat_service_title_class") オプションサービス
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('chat_option_service')") 修正
                    //- ディスク増設
                    template(v-if="hasOrder('chat.option.disk.disk_size') === true")
                      template(v-if="isNewOrder('chat.option.disk.disk_size')")
                        b-form-text.new-label-before(:class="chat_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_chat_disk_size }}
                      template(v-else-if="isChangeOrder('chat.option.disk.disk_size')")
                        b-form-text.change-label-before(:class="chat_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_chat_disk_size }}
                                template(v-if="getDiffUser('chat.option.disk.disk_size') > 0")
                                  span.text-success （+{{20 * getDiffUser('chat.option.disk.disk_size')}}GB）
                                template(v-else-if="getDiffUser('chat.option.disk.disk_size') < 0")
                                  span.text-info （{{20 * getDiffUser('chat.option.disk.disk_size')}}GB）
                      template(v-else-if="isCancelOrder('chat.option.disk.disk_size')")
                        b-form-text.cancel-label-before(:class="chat_service_data_class") ディスク増設
                      template(v-else)
                        b-form-text.none-label-before(:class="chat_service_data_class") ディスク増設
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left
                                span {{ display_chat_disk_size }}

                  //- Chatluckセキュリティオプション
                  template(v-if="hasChatSecurityOption()")
                    h5(:class="chat_service_title_class") セキュリティオプション
                      b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('chat_security_option')") 修正
                    //- BASIC認証
                    template(v-if="hasOrder('chat.security.basic') === true")
                      template(v-if="isNewOrder('chat.security.basic')")
                        b-form-text.new-label-before(:class="chat_service_data_class") BASIC認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザーID ： {{ display_order_info.chat.security.basic.basic_id }}
                              b-form-text.text-left パスワード ： {{ display_order_info.chat.security.basic.basic_password }}
                              template(v-if="display_order_info.chat.security.basic.basic_except_ip")
                                b-form-text.text-left 認証を除外するIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.chat.security.basic.basic_except_ip)") {{ip_addr}}
                      template(v-else-if="isChangeOrder('chat.security.basic')")
                        b-form-text.change-label-before(:class="chat_service_data_class") BASIC認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザーID ： {{ display_order_info.chat.security.basic.basic_id }}
                              b-form-text.text-left パスワード ： {{ display_order_info.chat.security.basic.basic_password }}
                              template(v-if="display_order_info.chat.security.basic.basic_except_ip")
                                b-form-text.text-left 認証を除外するIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.chat.security.basic.basic_except_ip)") {{ip_addr}}
                      template(v-else-if="isCancelOrder('chat.security.basic')")
                        b-form-text.cancel-label-before(:class="chat_service_data_class") BASIC認証
                      template(v-else)
                        b-form-text.none-label-before(:class="chat_service_data_class") BASIC認証
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left ユーザーID ： {{ display_order_info.chat.security.basic.basic_id }}
                              b-form-text.text-left パスワード ： {{ display_order_info.chat.security.basic.basic_password }}
                              template(v-if="display_order_info.chat.security.basic.basic_except_ip")
                                b-form-text.text-left 認証を除外するIPアドレス：
                                b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.chat.security.basic.basic_except_ip)") {{ip_addr}}
                    //- 接続元IPアドレス制限
                    template(v-if="hasOrder('chat.security.connect_permit_ip') === true")
                      template(v-if="isNewOrder('chat.security.connect_permit_ip')")
                        b-form-text.new-label-before(:class="chat_service_data_class") 接続元IPアドレス制限
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 接続を許可するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.chat.security.connect_permit_ip)") {{ip_addr}}
                      template(v-else-if="isChangeOrder('chat.security.connect_permit_ip')")
                        b-form-text.change-label-before(:class="chat_service_data_class") 接続元IPアドレス制限
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 接続を許可するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.chat.security.connect_permit_ip)") {{ip_addr}}
                      template(v-else-if="isCancelOrder('chat.security.connect_permit_ip')")
                        b-form-text.cancel-label-before(:class="chat_service_data_class") 接続元IPアドレス制限
                      template(v-else)
                        b-form-text.none-label-before(:class="chat_service_data_class") 接続元IPアドレス制限
                          b-row
                            b-col(cols="1")
                            b-col
                              b-form-text.text-left 接続を許可するIPアドレス：
                              b-form-text.text-left.ml-1(v-for="(ip_addr) of getFormattedIPAddress(display_order_info.chat.security.connect_permit_ip)") {{ip_addr}}
                  b-form-text(:class="chat_service_data_class")
                  b-form-text(style="height: 30px;")

                //- 変更希望日
                h5(:class="other_service_title_class") 変更希望日
                  b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('preferred_date')") 修正
                b-form-text(:class="other_service_data_class") {{ preferred_date }}
                b-form-text(style="height: 30px;")

                //- お見積番号
                h5(:class="other_service_title_class") お見積番号
                  b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('estimate')") 修正
                b-form-text(:class="other_service_data_class") {{ common_info.estimate_no }}
                b-form-text(style="height: 30px;")

                //- 備考
                h5(:class="other_service_title_class") 備考
                  b-button.anchor-button.ml-2(size="sm", @click="modifyOrder('remarks')") 修正
                b-form-text.white-space(:class="other_service_data_class") {{ common_info.order_remarks }}
                b-form-text(style="height: 30px;")

                contract-conditions.mx-3.mb-4(
                  :show-neo="plan_info.name !== ''",
                  :show-chat="['premium_user', 'chatplus_user'].includes(plan_info.name) || hasOrder('chat.chat_user')",
                  :show-clouza="hasOrder('neo.option.clouza')",
                  :show-arena="hasOrder('neo.mail.arena')",
                  :show-cyber="hasOrder('neo.mail.cyber')",
                  :show-mailgates="hasOrder('neo.mail_security.mailgates')")

                //- 見積書
                template(v-if="sales_channel !== '1' && has_special_priced_item === false")
                  h5(:class="other_service_title_class") 見積書を作成する
                  b-form-text(:class="other_service_data_class")
                    app-messages(:errorMessages="quotation_errors")
                    b-container.my-2
                      b-row
                        b-col(cols="1")
                        b-col(cols="7")
                          b-form-checkbox(v-model="total_quotation_flg" size="lg")
                            span 総額見積書
                            span.checkbox-description （変更反映後の総額費用）
                          b-form-checkbox(v-model="individual_quotation_flg" size="lg" :disabled="is_individual_quotation_available")
                            span 個別見積書
                            span.checkbox-description （変更分のみの差分費用）
                          b-form-text.ml-4 ※個別見積書はユーザー数の減算や解約申請、オプションの変更がない場合のみ作成できます。
                          b-form-text.ml-4 ※個別見積書は見積合計金額が0円の場合、作成することはできません。
                        b-col(cols="3")
                          b-button.float-right.mr-5.mt-5(pill, variant="outline-success", size="lg", @click="createQuotation", :disabled="is_loading")
                            .float-left.search_message.mr-1.font-weight-bold 見積書作成
                            b-icon.float-right.next-icon(icon="arrow-right-circle")
                  b-form-text(style="height: 30px;")

                //- 申し込む
                h5(:class="other_service_title_class") 変更を申し込む
                b-form-text(:class="other_service_data_class")
                  b-container.my-2
                    b-row
                      b-col(cols="1")
                      b-col(cols="6")
                        b-button(pill, variant="outline-secondary", size="lg", @click="moveInputPage", :disabled="is_loading")
                          .float-right.search_message.ml-1.font-weight-bold 申し込み内容を修正する
                          b-icon.float-left.next-icon(icon="arrow-left-circle")
                      b-col(cols="4")
                        b-button.order-confirm-button.float-right.mr-5(pill, variant="outline-success", size="lg", @click="applyOrder", :disabled="is_loading")
                          span.search_message.mr-1.font-weight-bold 申し込みを確定する
                          b-icon.next-icon(icon="arrow-right-circle")

</template>

<script>
// コンポーネント
import Loading from '@/components/Loading'
import AppMessages from '@/components/AppMessages';
import ContractConditions from "@/components/ContractConditions";

// API関連
import Api from '@/repositories/api'
const S213ContractChanges = Api.get('s213ContractChanges')
const S213ContractDetails = Api.get('s213ContractDetails')
const S214Quotation = Api.get('s214Quotation');

export default {
  name: "ConfirmChanges",
  components: {
    Loading,
    AppMessages,
    ContractConditions,
  },
  props: {
    // 販売経由
    sales_channel: { type: String, required: true },
    // 優待価格商品保有フラグ
    has_special_priced_item: { type: Boolean, required: true },
    // 契約情報
    contract_info: { type: Object, required: true },
    // 注文情報
    order_info: { type: Object, required: true },
    // その他情報
    common_info: { type: Object, required: true },
  },
  data() {
    return {
      // クラス
      plan_service_title_class: "ml-3 py-2 mr-0 font-weight-bold border-top border-bottom plan-title-bg-color",
      plan_service_data_class: "ml-3 py-2 px-2 border-top border-bottom border-color-plan label-font-size",
      neo_service_title_class: "ml-3 py-2 font-weight-bold border-top border-bottom neo-title-bg-color",
      neo_service_data_class: "ml-3 pt-2 px-2 mb-2 border-top border-primary label-font-size",
      chat_service_title_class: "ml-3 py-2 font-weight-bold border-top border-bottom chat-title-bg-color",
      chat_service_data_class: "ml-3 pt-2 px-2 mb-2 border-top border-success label-font-size",
      other_service_title_class: "ml-3 py-2 font-weight-bold border-top border-bottom other-title-bg-color ",
      other_service_data_class: "ml-3 py-2 px-2 mb-2 border-top border-bottom border-color-other label-font-size",

      // 見積枝番
      estimate_branch: '',
      // 表示する注文内容
      display_order_info: {
        light_user: '',
        standard_user: '',
        premium_user: '',
        chatplus_user: '',
        neo: {
          neo_user: '',
          app_suite_user: '',
          app_suite_user_old: '',
          web_conferencing: '',
          cloud_db_user: '',
          option: {
            room_mgr: false,
            expense_settlement: false,
            clouza: {
              user: '',
              clouza_company: '',
              paid_leave_option: false
            },
            disk: {
              disk_size: '',
              disk_size_old: ''
            },
            sync: {
              user: ''
            },
            dn_drive: {
              disk_size: ''
            }
          },
          security: {
            basic: {
              basic_id: '',
              basic_password: '',
              basic_except_ip: ''
            },
            connect_permit_ip: '',
            secure: {
              secure_browser_terminal: '',
              secure_browser_device: '',
              secure_except_ip: '',
              secure_browser_certificate_action: '04',
              secure_browser_re_create: '',
              secure_browser_delete_certificate: '',
            },
            client: {
              device: '',
              cert_except_ip: ''
            }
          },
          mail: {
            arena: {
              wa_domain: '',
              account: ''
            },
            cyber: {
              account: '',
              mailbox: '00',
              options: [],
              keep: '00'
            }
          },
          mail_security: {
            mailgates: {
              mailgates_domain: '',
              account: '',
              options: []
            }
          },
        },
        chat: {
          chat_user: '',
          option: {
            disk: {
              disk_size: ''
            }
          },
          security: {
            basic: {
              basic_id: '',
              basic_password: '',
              basic_except_ip: ''
            },
            connect_permit_ip: ''
          },
        },
      },

      // 見積書フラグ
      total_quotation_flg: false,
      individual_quotation_flg: false,

      // ローディングフラグ
      init_loading: false,
      is_loading: false,

      // エラーメッセージ
      order_errors: [],
      quotation_errors: [],
    }
  },
  computed: {
    /**
     * プラン情報を取得する
     */
    plan_info() {
      // プラン情報
      let arPlans = ['light_user', 'standard_user', 'premium_user', 'chatplus_user']
      // 各プラン情報が注文情報に含まれるか確認する
      for(let iIndex = 0; iIndex < arPlans.length; iIndex++) {
        // 注文情報に存在する場合
        if (this.display_order_info[arPlans[iIndex]] !== '') {
          // レスポンスとして返す
          return {
            name: arPlans[iIndex],
            user: this.display_order_info[arPlans[iIndex]]
          }
        }
      }

      // desknet's NEOが含まれるか確認する
      if ('neo' in this.display_order_info && 'neo_user' in this.display_order_info.neo && this.display_order_info.neo.neo_user !== '') {
        // レスポンスとして返す
        return {
          name: 'neo.neo_user',
          user: this.display_order_info.neo.neo_user
        }
      }

      // 上記以外はデフォルトを返す
      return {
        name: '',
        user: 0
      }
    },
    /**
     * CYBERMAILΣのメールボックス容量を返す
     */
    cybermail_mailbox_size() {
      // メールボックスサイズを返す
      switch (this.display_order_info.neo.mail.cyber.mailbox) {
        // 5GBの場合
        case '01':
          return '5'
        // 10GBの場合
        case '02':
          return '10'
        // 50GBの場合
        case '03':
          return '50'
        // 100GBの場合
        case '04':
          return '100'
        // 上記以外の場合
        default:
          // 空文字を返す
          return ''
      }
    },
    /**
     * CYBERMAILΣの保存期間を返す
     */
    cybermail_keep() {
      // メールボックスサイズを返す
      switch (this.display_order_info.neo.mail.cyber.keep) {
        // 5年保存の場合
        case '01':
          return '5'
        // 7年保存の場合
        case '02':
          return '7'
        // 10年保存の場合
        case '03':
          return '10'
        // 上記以外の場合
        default:
          // 空文字を返す
          return ''
      }
    },
    /**
     * ディスク容量を取得する
     */
    display_disk_size() {
      return this.getDisplayDiskSize(this.display_order_info.neo.option.disk.disk_size)
    },
    /**
     * 旧ディスク容量を取得する
     */
    display_disk_size_old() {
      return this.getDisplayDiskSize(this.display_order_info.neo.option.disk.disk_size_old)
    },
    /**
     * desknet'sドライブ ディスク容量を取得する
     */
    display_dn_drive_disk_size() {
      return this.getDisplayDndriveDiskSize(this.display_order_info.neo.option.dn_drive.disk_size)
    },
    /**
     * BASIC認証の表示用除外IPアドレスを取得する
     */
    display_basic_ip() {
      return this.getFormattedIPAddress(this.display_order_info.neo.security.basic.basic_except_ip).join('\n')
    },
    /**
     * CYBERMAILΣの情報漏えい対策を利用しているか
     */
    has_cyber_option_misdelivery_and_attached_encoding() {
      // 情報漏えい対策を利用しているか確認する
      return this.hasCyberOption('00')
    },
    /**
     * CYBERMAILΣの添付ファイル暗号化・分離を利用しているか
     */
    has_cyber_option_misdelivery_measure() {
      // 添付ファイル暗号化・分離を利用しているか確認する
      return this.hasCyberOption('01')
    },
    /**
     * CYBERMAILΣのアーカイブ＆監査を利用しているか
     */
    has_cyber_option_archive() {
      // アーカイブ＆監査を利用しているか確認する
      return this.hasCyberOption('02')
    },
    /**
     * CYBERMAILΣのサンドボックスを利用しているか
     */
    has_cyber_option_sandbox() {
      // サンドボックスを利用しているか確認する
      return this.hasCyberOption('03')
    },
    /**
     * MAILGATESΣのアンチウイルス・スパム＋サンドボックスを利用しているか
     */
    has_mailgates_option_antivirus_sandbox() {
      // アンチウイルス・スパム＋サンドボックスを利用しているか確認する
      return this.hasMailgatesOption('01')
    },
    /**
     * MAILGATESΣの誤送信対策・審査を利用しているか
     */
    has_mailgates_option_prevent_missend() {
      // 誤送信対策・審査を利用しているか確認する
      return this.hasMailgatesOption('02')
    },
    /**
     * MAILGATESΣの添付ファイル暗号化・分離を利用しているか
     */
    has_mailgates_option_separation() {
      // 添付ファイル暗号化・分離を利用しているか確認する
      return this.hasMailgatesOption('03')
    },
    /**
     * ChatLuckディスク容量を取得する
     */
    display_chat_disk_size() {
      return this.getDisplayDiskSize(this.display_order_info.chat.option.disk.disk_size)
    },
    /**
     * 変更希望日の表示形式を変える
     */
    preferred_date() {
      // 2021年12月2日(木) のような形式にする
      return this.showDateString(this.common_info.opening_date)
    },
    /**
     * 個別見積書チェックボックスの有効/無効を判定する
     */
    is_individual_quotation_available() {
      // 各変更対象製品を見ていく
      for (const item of this.common_info.target_product) {
        // 解約申請の場合
        if (item.order_type === '2') {
          // 選択できないようにする
          return true
        }
        // 新規の場合は無視
        if (item.order_type === '0') {
          continue
        }

        // 変更対象製品名に対応する項目をチェックする
        switch (item.name) {
          // ユーザー数が減算されるオプションの場合
          case 'light_user':
          case 'standard_user':
          case 'premium_user':
          case 'chatplus_user':
          case 'neo.neo_user':
          case 'neo.app_suite_user':
          case 'neo.app_suite_user_old':
          case 'neo.web_conferencing':
          case 'neo.option.disk.disk_size':
          case 'neo.option.disk.disk_size_old':
          case 'neo.option.sync':
          case 'neo.option.dn_drive':
          case 'chat.chat_user':
          case 'chat.option.disk.disk_size':
            // ユーザー数が減算されている場合
            if (this.getDiffUser(item.name) < 0) {
              // 選択できないようにする
              return true
            }
            break
          // CLOUZA+タイムカードの場合
          case 'neo.option.clouza':
            // ユーザー数が減算されている場合
            if (this.getDiffUser('neo.option.clouza') < 0) {
              // 選択できないようにする
              return true
            }
            // 会社コードが変更されている場合
            if (this.display_order_info.neo.option.clouza.clouza_company !== this.contract_info.neo.option.clouza.clouza_company) {
              // 選択できないようにする
              return true
            }
            // 有休管理オプションが解約されている場合
            if (this.display_order_info.neo.option.clouza.paid_leave_option === false && this.contract_info.neo.option.clouza.paid_leave_option === true) {
              // 選択できないようにする
              return true
            }
            break
          // BASIC認証の場合
          case 'neo.security.basic':
            // ユーザーIDが変更されている場合
            if (this.display_order_info.neo.security.basic.basic_id !== this.contract_info.neo.security.basic.basic_id) {
              // 選択できないようにする
              return true
            }
            // パスワードが変更されている場合
            if (this.display_order_info.neo.security.basic.basic_password !== this.contract_info.neo.security.basic.basic_password) {
              // 選択できないようにする
              return true
            }
            // 除外IPアドレスが変更されている場合
            if (this.display_order_info.neo.security.basic.basic_except_ip !== this.contract_info.neo.security.basic.basic_except_ip) {
              // 選択できないようにする
              return true
            }
            break
          // 接続元IPアドレス制限の場合
          case 'neo.security.connect_permit_ip':
            // 接続許可IPアドレスが変更されている場合
            if (this.display_order_info.neo.security.connect_permit_ip !== this.contract_info.neo.security.connect_permit_ip) {
              // 選択できないようにする
              return true
            }
            break
          // クライアント認証の場合
          case 'neo.security.client':
            // デバイス数が減算されている場合
            if (this.getDiffUser('neo.security.client') < 0) {
              // 選択できないようにする
              return true
            }
            // 除外IPアドレスが変更されている場合
            if (this.display_order_info.neo.security.client.cert_except_ip !== this.contract_info.neo.security.client.cert_except_ip) {
              // 選択できないようにする
              return true
            }
            break
          // セキュアブラウザの場合
          case 'neo.security.secure':
            // 端末認証方式が変更されている場合
            if (this.display_order_info.neo.security.secure.secure_browser_terminal !== this.contract_info.neo.security.secure.secure_browser_terminal) {
              // 選択できないようにする
              return true
            }
            // 端末認証ありの場合
            if (this.display_order_info.neo.security.secure.secure_browser_terminal === '02') {
              // 証明書の追加以外が選択されている場合
              if (this.display_order_info.neo.security.secure.secure_browser_certificate_action !== '01') {
                // 選択できないようにする
                return true
              }
            }
            // 除外IPアドレスが変更されている場合
            if (this.display_order_info.neo.security.secure.secure_except_ip !== this.contract_info.neo.security.secure.secure_except_ip) {
              // 選択できないようにする
              return true
            }
            break
          // WebARENAの場合
          case 'neo.mail.arena':
            // アカウント数が減算されている場合
            if (this.getDiffUser('neo.mail.arena') < 0) {
              // 選択できないようにする
              return true
            }
            // 利用ドメイン名が変更されている場合
            if (this.display_order_info.neo.mail.arena.wa_domain !== this.contract_info.neo.mail.arena.wa_domain) {
              // 選択できないようにする
              return true
            }
            break
          // CYBERMAILΣの場合
          case 'neo.mail.cyber': {
            // アカウント数が減算されている場合
            if (this.getDiffUser('neo.mail.cyber') < 0) {
              // 選択できないようにする
              return true
            }
            // メールボックス容量が変更されている場合
            if (this.display_order_info.neo.mail.cyber.mailbox !== this.contract_info.neo.mail.cyber.mailbox) {
              // 選択できないようにする
              return true
            }
            // 申し込み内容と契約内容のオプションの差を取得する
            const arDiffs = [
              ...this.display_order_info.neo.mail.cyber.options.filter(item => !this.contract_info.neo.mail.cyber.options.includes(item)),
              ...this.contract_info.neo.mail.cyber.options.filter(item => !this.display_order_info.neo.mail.cyber.options.includes(item)),
            ];
            // オプションが変更されている場合
            if (arDiffs.length > 0) {
              // 選択できないようにする
              return true
            }
            // メールアーカイブ&監査を選択している場合
            if (this.display_order_info.neo.mail.cyber.options.includes('02') === true) {
              // 保存期間が変更されている場合
              if (this.display_order_info.neo.mail.cyber.keep !== this.contract_info.neo.mail.cyber.keep) {
                // 選択できないようにする
                return true
              }
            }
            break
          }
          // MAILGATESΣの場合
          case 'neo.mail_security.mailgates': {
            // アカウント数が減算されている場合
            if (this.getDiffUser('neo.mail_security.mailgates') < 0) {
              // 選択できないようにする
              return true
            }
            // 利用ドメイン名が変更されている場合
            if (this.display_order_info.neo.mail_security.mailgates.mailgates_domain !== this.contract_info.neo.mail_security.mailgates.mailgates_domain) {
              // 選択できないようにする
              return true
            }
            // 申し込み内容と契約内容のオプションの差を取得する
            const arDiffs = [
              ...this.display_order_info.neo.mail_security.mailgates.options.filter(item => !this.contract_info.neo.mail_security.mailgates.options.includes(item)),
              ...this.contract_info.neo.mail_security.mailgates.options.filter(item => !this.display_order_info.neo.mail_security.mailgates.options.includes(item)),
            ];
            // オプションが変更されている場合
            if (arDiffs.length > 0) {
              // 選択できないようにする
              return true
            }
            break
          }
          // ChatLuck BASIC認証の場合
          case 'chat.security.basic':
            // ユーザーIDが変更されている場合
            if (this.display_order_info.chat.security.basic.basic_id !== this.contract_info.chat.security.basic.basic_id) {
              // 選択できないようにする
              return true
            }
            // パスワードが変更されている場合
            if (this.display_order_info.chat.security.basic.basic_password !== this.contract_info.chat.security.basic.basic_password) {
              // 選択できないようにする
              return true
            }
            // 除外IPアドレスが変更されている場合
            if (this.display_order_info.chat.security.basic.basic_except_ip !== this.contract_info.chat.security.basic.basic_except_ip) {
              // 選択できないようにする
              return true
            }
            break
          // ChatLuck 接続元IPアドレス制限の場合
          case 'chat.security.connect_permit_ip':
            // 接続許可IPアドレスが変更されている場合
            if (this.display_order_info.chat.security.connect_permit_ip !== this.contract_info.chat.security.connect_permit_ip) {
              // 選択できないようにする
              return true
            }
            break
          // 上記以外の場合
          default:
            // 何もしない
            break
        }
      }

      // 上記以外は選択できるようにする
      return false
    },
  },
  created() {
    // セッションストレージから見積枝番を取得
    const estimateBranch = sessionStorage.getItem('estimate_branch');

    // ローディング開始
    this.init_loading = true

    // 値が存在し、かつ空文字やnullでない場合
    if (estimateBranch !== null && estimateBranch !== '') {
      // 見積枝番を保存する
      this.estimate_branch = estimateBranch

      // S21403_見積内容取得処理を実行する
      S214Quotation.detail({estimate_branch: estimateBranch})
        .then((responseQuote) => {
          // 契約番号を取得
          this.common_info.contract_no = responseQuote.data.data.contract_no
          // 変更希望日を上書き
          this.common_info.opening_date = responseQuote.data.opening_date
          // 見積番号を上書き
          this.common_info.estimate_no = responseQuote.data.estimate_no
          // 注文備考を上書き
          this.common_info.order_remarks = responseQuote.data.order_note
          // 変更対象製品を上書き
          this.common_info.target_product = responseQuote.data.target_product

          // S21301_契約内容取得処理を実行する
          S213ContractDetails.view({contract_no: this.common_info.contract_no})
            .then((responseContract) => {
              // 契約情報と注文情報を上書き
              this.setContractAndOrderInfo(responseContract.data.data[0], responseQuote.data.data)
                .then(() => {
                  // 注文情報にセキュアブラウザの現在のデバイス数が設定されていない場合
                  if (('now_secure_browser_device' in this.order_info.neo.security.secure) === false) {
                    // 契約情報のデバイス数を設定する
                    this.order_info.neo.security.secure.now_secure_browser_device = this.contract_info.neo.security.secure.secure_browser_device
                  }
                  // ローディング終了
                  this.init_loading = false
                })
            })
            .catch((error) => {
              // 共通エラー処理
              this.apiError(error, '画面表示処理', 'Service')
              // エラーメッセージを表示する
              this.setErrors(error)
              this.order_errors = this.errors
              // 画面一番上へスクロールをする
              this.pageTopScroll()
              // ローディング終了
              this.init_loading = false
            })
        })
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, '画面表示処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          this.order_errors = this.errors
          // 画面一番上へスクロールをする
          this.pageTopScroll()
          // ローディング終了
          this.init_loading = false
        })
    }
    // 見積枝番が存在しない場合
    else {
      // 表示する注文情報を設定
      this.setDisplayOrderInfo()
        .then(() => {
          // ローディング終了
          this.init_loading = false
        })
    }
  },
  methods: {
    /**
     * 契約情報と注文情報を上書きする
     *
     * @param {object} responseContract 取得した契約情報
     * @param {object} responseOrder    取得した注文情報
     */
    async setContractAndOrderInfo(responseContract, responseOrder) {
      // 取得した契約情報を契約情報と注文情報に設定する
      await this.setInformation(this.contract_info, responseContract)
      await this.setInformation(this.order_info, responseContract)
      // 取得した注文情報を注文情報に設定する
      await this.setInformation(this.order_info, responseOrder)
      // 表示する注文情報を設定
      await this.setDisplayOrderInfo()
    },
    /**
     * 情報を上書きする
     *
     * @param {object} targetInfo  設定される側の情報
     * @param {object} settingInfo 設定する側の情報
     */
    setInformation(targetInfo, settingInfo) {
      // 設定する側にデータが存在する場合、設定される側のデータを更新する
      // ライトユーザーが設定されている場合
      if ('light_user' in settingInfo) {
        targetInfo.light_user = settingInfo.light_user
      }
      // スタンダードユーザーが設定されている場合
      if ('standard_user' in settingInfo) {
        targetInfo.standard_user = settingInfo.standard_user
      }
      // プレミアムユーザーが設定されている場合
      if ('premium_user' in settingInfo) {
        targetInfo.premium_user = settingInfo.premium_user
      }
      // チャットプラスユーザーが設定されている場合
      if ('chatplus_user' in settingInfo) {
        targetInfo.chatplus_user = settingInfo.chatplus_user
      }
      // neoが設定されている場合
      if ('neo' in settingInfo) {
        // 設定先にneoの階層がない場合は設定する
        if (('neo' in targetInfo) === false) {
          targetInfo.neo = {}
        }

        // desknet's NEOユーザーが設定されている場合
        if ('neo_user' in settingInfo.neo) {
          targetInfo.neo.neo_user = settingInfo.neo.neo_user
        }
        // AppSuiteユーザーが設定されている場合
        if ('app_suite_user' in settingInfo.neo) {
          targetInfo.neo.app_suite_user = settingInfo.neo.app_suite_user
        }
        // 旧AppSuiteユーザーが設定されている場合
        if ('app_suite_user_old' in settingInfo.neo) {
          targetInfo.neo.app_suite_user_old = settingInfo.neo.app_suite_user_old
        }
        // ウェブ会議が設定されている場合
        if ('web_conferencing' in settingInfo.neo) {
          targetInfo.neo.web_conferencing = settingInfo.neo.web_conferencing
        }
        // desknet's DBが設定されている場合
        if ('cloud_db_user' in settingInfo.neo) {
          targetInfo.neo.cloud_db_user = settingInfo.neo.cloud_db_user
        }
        // オプションが設定されている場合
        if ('option' in settingInfo.neo) {
          // 設定先にoptionの階層がない場合は設定する
          if (('option' in targetInfo.neo) === false) {
            targetInfo.neo.option = {}
          }

          // RoomMgrが設定されている場合
          if ('room_mgr' in settingInfo.neo.option) {
            targetInfo.neo.option.room_mgr = settingInfo.neo.option.room_mgr
          }
          // 交通費・経費精算が設定されている場合
          if ('expense_settlement' in settingInfo.neo.option) {
            targetInfo.neo.option.expense_settlement = settingInfo.neo.option.expense_settlement
          }
          // CLOUZAが設定されている場合
          if ('clouza' in settingInfo.neo.option) {
            // 設定先にclouzaの階層がない場合は設定する
            if (('clouza' in targetInfo.neo.option) === false) {
              targetInfo.neo.option.clouza = {}
            }

            // ユーザー数が設定されている場合
            if ('user' in settingInfo.neo.option.clouza) {
              targetInfo.neo.option.clouza.user = settingInfo.neo.option.clouza.user
            }
            // CLOUZA会社コードが設定されている場合
            if ('clouza_company' in settingInfo.neo.option.clouza) {
              targetInfo.neo.option.clouza.clouza_company = settingInfo.neo.option.clouza.clouza_company
            }
            // 有休管理オプションが設定されている場合
            if ('paid_leave_option' in settingInfo.neo.option.clouza) {
              targetInfo.neo.option.clouza.paid_leave_option = settingInfo.neo.option.clouza.paid_leave_option
            }
          }
          // ディスク容量が設定されている場合
          if ('disk' in settingInfo.neo.option) {
            // 設定先にdiskの階層がない場合は設定する
            if (('disk' in targetInfo.neo.option) === false) {
              targetInfo.neo.option.disk = {}
            }

            // ディスク容量が設定されている場合
            if ('disk_size' in settingInfo.neo.option.disk) {
              targetInfo.neo.option.disk.disk_size = settingInfo.neo.option.disk.disk_size
            }
            // 旧ディスク容量が設定されている場合
            if ('disk_size_old' in settingInfo.neo.option.disk) {
              targetInfo.neo.option.disk.disk_size_old = settingInfo.neo.option.disk.disk_size_old
            }
          }
          // Sync for smartphoneが設定されている場合
          if ('sync' in settingInfo.neo.option) {
            // 設定先にsyncの階層がない場合は設定する
            if (('sync' in targetInfo.neo.option) === false) {
              targetInfo.neo.option.sync = {}
            }

            // ユーザー数が設定されている場合
            if ('user' in settingInfo.neo.option.sync) {
              targetInfo.neo.option.sync.user = settingInfo.neo.option.sync.user
            }
          }
          // desknet'Sドライブ ディスク増設が設定されている場合
          if ('dn_drive' in settingInfo.neo.option) {
            // 設定先にdn_driveの階層がない場合は設定する
            if (('dn_drive' in targetInfo.neo.option) === false) {
              targetInfo.neo.option.dn_drive = {}
            }

            // ディスク容量が設定されている場合
            if ('disk_size' in settingInfo.neo.option.dn_drive) {
              targetInfo.neo.option.dn_drive.disk_size = settingInfo.neo.option.dn_drive.disk_size
            }
          }
        }
        // セキュリティが設定されている場合
        if ('security' in settingInfo.neo) {
          // 設定先にsecurityの階層がない場合は設定する
          if (('security' in targetInfo.neo) === false) {
            targetInfo.neo.security = {}
          }

          // BASIC認証が設定されている場合
          if ('basic' in settingInfo.neo.security) {
            // 設定先にbasicの階層がない場合は設定する
            if (('basic' in targetInfo.neo.security) === false) {
              targetInfo.neo.security.basic = {}
            }

            // BASIC IDが設定されている場合
            if ('basic_id' in settingInfo.neo.security.basic) {
              targetInfo.neo.security.basic.basic_id = settingInfo.neo.security.basic.basic_id
            }
            // BASIC パスワードが設定されている場合
            if ('basic_password' in settingInfo.neo.security.basic) {
              targetInfo.neo.security.basic.basic_password = settingInfo.neo.security.basic.basic_password
            }
            // 除外IPアドレスが設定されている場合
            if ('basic_except_ip' in settingInfo.neo.security.basic) {
              targetInfo.neo.security.basic.basic_except_ip = settingInfo.neo.security.basic.basic_except_ip
            }
          }
          // 接続元IPアドレスが設定されている場合
          if ('connect_permit_ip' in settingInfo.neo.security) {
            targetInfo.neo.security.connect_permit_ip = settingInfo.neo.security.connect_permit_ip
          }
          // セキュアブラウザが設定されている場合
          if ('secure' in settingInfo.neo.security) {
            // 設定先にsecureの階層がない場合は設定する
            if (('secure' in targetInfo.neo.security) === false) {
              targetInfo.neo.security.secure = {}
            }

            // 端末認証フラグが設定されている場合
            if ('secure_browser_terminal' in settingInfo.neo.security.secure) {
              targetInfo.neo.security.secure.secure_browser_terminal = settingInfo.neo.security.secure.secure_browser_terminal
            }
            // 現在のデバイス数が設定されている場合
            if ('now_secure_browser_device' in settingInfo.neo.security.secure) {
              targetInfo.neo.security.secure.now_secure_browser_device = settingInfo.neo.security.secure.now_secure_browser_device
            }
            // デバイス数が設定されている場合
            if ('secure_browser_device' in settingInfo.neo.security.secure) {
              targetInfo.neo.security.secure.secure_browser_device = settingInfo.neo.security.secure.secure_browser_device
            }
            // 除外IPアドレスが設定されている場合
            if ('secure_except_ip' in settingInfo.neo.security.secure) {
              targetInfo.neo.security.secure.secure_except_ip = settingInfo.neo.security.secure.secure_except_ip
            }
            // 証明書操作が設定されている場合
            if ('secure_browser_certificate_action' in settingInfo.neo.security.secure) {
              targetInfo.neo.security.secure.secure_browser_certificate_action = settingInfo.neo.security.secure.secure_browser_certificate_action
            }
            // 再発行証明書が設定されている場合
            if ('secure_browser_re_create' in settingInfo.neo.security.secure) {
              targetInfo.neo.security.secure.secure_browser_re_create = settingInfo.neo.security.secure.secure_browser_re_create
            }
            // 削減証明書が設定されている場合
            if ('secure_browser_delete_certificate' in settingInfo.neo.security.secure) {
              targetInfo.neo.security.secure.secure_browser_delete_certificate = settingInfo.neo.security.secure.secure_browser_delete_certificate
            }
          }
          // クライアント認証が設定されている場合
          if ('client' in settingInfo.neo.security) {
            // 設定先にclientの階層がない場合は設定する
            if (('client' in targetInfo.neo.security) === false) {
              targetInfo.neo.security.client = {}
            }

            // デバイス数が設定されている場合
            if ('device' in settingInfo.neo.security.client) {
              targetInfo.neo.security.client.device = settingInfo.neo.security.client.device
            }
            // 除外IPアドレスが設定されている場合
            if ('cert_except_ip' in settingInfo.neo.security.client) {
              targetInfo.neo.security.client.cert_except_ip = settingInfo.neo.security.client.cert_except_ip
            }
          }
        }
        // メールが設定されている場合
        if ('mail' in settingInfo.neo) {
          // 設定先にmailの階層がない場合は設定する
          if (('mail' in targetInfo.neo) === false) {
            targetInfo.neo.mail = {}
          }

          // Web ARENAが設定されている場合
          if ('arena' in settingInfo.neo.mail) {
            // 設定先にarenaの階層がない場合は設定する
            if (('arena' in targetInfo.neo.mail) === false) {
              targetInfo.neo.mail.arena = {}
            }

            // ドメイン名が設定されている場合
            if ('wa_domain' in settingInfo.neo.mail.arena) {
              targetInfo.neo.mail.arena.wa_domain = settingInfo.neo.mail.arena.wa_domain
            }
            // アカウント数が設定されている場合
            if ('account' in settingInfo.neo.mail.arena) {
              targetInfo.neo.mail.arena.account = settingInfo.neo.mail.arena.account
            }
          }
          // CYBERMAILΣが設定されている場合
          if ('cyber' in settingInfo.neo.mail) {
            // 設定先にcyberの階層がない場合は設定する
            if (('cyber' in targetInfo.neo.mail) === false) {
              targetInfo.neo.mail.cyber = {}
            }

            // アカウント数が設定されている場合
            if ('account' in settingInfo.neo.mail.cyber) {
              targetInfo.neo.mail.cyber.account = settingInfo.neo.mail.cyber.account
            }
            // メールボックス容量が設定されている場合
            if ('mailbox' in settingInfo.neo.mail.cyber) {
              targetInfo.neo.mail.cyber.mailbox = settingInfo.neo.mail.cyber.mailbox
            }
            // オプションが設定されている場合
            if ('options' in settingInfo.neo.mail.cyber) {
              targetInfo.neo.mail.cyber.options = settingInfo.neo.mail.cyber.options
            }
            // 上記以外の場合
            else {
              // 空を設定
              targetInfo.neo.mail.cyber.options = []
            }
            // 保存期間が設定されている場合
            if ('keep' in settingInfo.neo.mail.cyber) {
              targetInfo.neo.mail.cyber.keep = settingInfo.neo.mail.cyber.keep
            }
          }
        }
        // メールセキュリティが設定されている場合
        if ('mail_security' in settingInfo.neo) {
          // 設定先にmail_securityの階層がない場合は設定する
          if (('mail_security' in targetInfo.neo) === false) {
            targetInfo.neo.mail_security = {}
          }

          // MAILGATESΣが設定されている場合
          if ('mailgates' in settingInfo.neo.mail_security) {
            // 設定先にmailgatesの階層がない場合は設定する
            if (('mailgates' in targetInfo.neo.mail_security) === false) {
              targetInfo.neo.mail_security.mailgates = {}
            }

            // ドメイン名が設定されている場合
            if ('mailgates_domain' in settingInfo.neo.mail_security.mailgates) {
              targetInfo.neo.mail_security.mailgates.mailgates_domain = settingInfo.neo.mail_security.mailgates.mailgates_domain
            }
            // アカウント数が設定されている場合
            if ('account' in settingInfo.neo.mail_security.mailgates) {
              targetInfo.neo.mail_security.mailgates.account = settingInfo.neo.mail_security.mailgates.account
            }
            // オプションが設定されている場合
            if ('options' in settingInfo.neo.mail_security.mailgates) {
              targetInfo.neo.mail_security.mailgates.options = settingInfo.neo.mail_security.mailgates.options
            }
            // 上記以外の場合
            else {
              // 空を設定
              targetInfo.neo.mail.cyber.options = []
            }
          }
        }
      }
      // Chatが設定されている場合
      if ('chat' in settingInfo) {
        // 設定先にchatの階層がない場合は設定する
        if (('chat' in targetInfo) === false) {
          targetInfo.chat = {}
        }

        // ChatLuckユーザー数が設定されている場合
        if ('chat_user' in settingInfo.chat) {
          targetInfo.chat.chat_user = settingInfo.chat.chat_user
        }
        // オプションが設定されている場合
        if ('option' in settingInfo.chat) {
          // 設定先にoptionの階層がない場合は設定する
          if (('option' in targetInfo.chat) === false) {
            targetInfo.chat.option = {}
          }

          // ディスク容量が設定されている場合
          if ('disk' in settingInfo.chat.option) {
            // 設定先にdiskの階層がない場合は設定する
            if (('disk' in targetInfo.chat.option) === false) {
              targetInfo.chat.option.disk = {}
            }

            // ディスク容量が設定されている場合
            if ('disk_size' in settingInfo.chat.option.disk) {
              targetInfo.chat.option.disk.disk_size = settingInfo.chat.option.disk.disk_size
            }
          }
        }
        // セキュリティが設定されている場合
        if ('security' in settingInfo.chat) {
          // 設定先にsecurityの階層がない場合は設定する
          if (('security' in targetInfo.chat) === false) {
            targetInfo.chat.security = {}
          }

          // BASIC認証が設定されている場合
          if ('basic' in settingInfo.chat.security) {
            // 設定先にbasicの階層がない場合は設定する
            if (('basic' in targetInfo.chat.security) === false) {
              targetInfo.chat.security.basic = {}
            }

            // BASIC IDが設定されている場合
            if ('basic_id' in settingInfo.chat.security.basic) {
              targetInfo.chat.security.basic.basic_id = settingInfo.chat.security.basic.basic_id
            }
            // BASIC パスワードが設定されている場合
            if ('basic_password' in settingInfo.chat.security.basic) {
              targetInfo.chat.security.basic.basic_password = settingInfo.chat.security.basic.basic_password
            }
            // 除外IPアドレスが設定されている場合
            if ('basic_except_ip' in settingInfo.chat.security.basic) {
              targetInfo.chat.security.basic.basic_except_ip = settingInfo.chat.security.basic.basic_except_ip
            }
          }
          // 接続元IPアドレスが設定されている場合
          if ('connect_permit_ip' in settingInfo.chat.security) {
            targetInfo.chat.security.connect_permit_ip = settingInfo.chat.security.connect_permit_ip
          }
        }
      }
    },
    /**
     * 表示する注文情報を設定
     */
    async setDisplayOrderInfo() {
      // 表示する注文情報に契約情報をコピー
      await this.setInformation(this.display_order_info, this.contract_info)

      // 変更対象製品をループ
      await this.common_info.target_product.forEach(item => {
        // 変更対象製品に存在する値は注文情報に置き換える
        switch (item.name) {
          // ライトプランの場合
          case 'light_user':
            this.display_order_info.light_user = this.order_info.light_user
            break
          // スタンダードプランの場合
          case 'standard_user':
            this.display_order_info.standard_user = this.order_info.standard_user
            break
          // プレミアムプランの場合
          case 'premium_user':
            this.display_order_info.premium_user = this.order_info.premium_user
            break
          // チャットプランの場合
          case 'chatplus_user':
            this.display_order_info.chatplus_user = this.order_info.chatplus_user
            break
          // desknet's NEOの場合
          case 'neo.neo_user':
            this.display_order_info.neo.neo_user = this.order_info.neo.neo_user
            break
          // AppSuiteの場合
          case 'neo.app_suite_user':
            this.display_order_info.neo.app_suite_user = this.order_info.neo.app_suite_user
            break
          // 旧AppSuiteの場合
          case 'neo.app_suite_user_old':
            this.display_order_info.neo.app_suite_user_old = this.order_info.neo.app_suite_user_old
            break
          // ウェブ会議の場合
          case 'neo.web_conferencing':
            this.display_order_info.neo.web_conferencing = this.order_info.neo.web_conferencing
            break
          // RoomMgrの場合
          case 'neo.option.room_mgr':
            this.display_order_info.neo.option.room_mgr = this.order_info.neo.option.room_mgr
            break
          // 交通費・経費精算の場合
          case 'neo.option.expense_settlement':
            this.display_order_info.neo.option.expense_settlement = this.order_info.neo.option.expense_settlement
            break
          // タイムカード+CLOUZAの場合
          case 'neo.option.clouza':
            this.display_order_info.neo.option.clouza.user = this.order_info.neo.option.clouza.user
            this.display_order_info.neo.option.clouza.clouza_company = this.order_info.neo.option.clouza.clouza_company
            this.display_order_info.neo.option.clouza.paid_leave_option = this.order_info.neo.option.clouza.paid_leave_option
            break
          // ディスク増設の場合
          case 'neo.option.disk.disk_size':
            this.display_order_info.neo.option.disk.disk_size = this.order_info.neo.option.disk.disk_size
            break
          // 旧ディスク増設の場合
          case 'neo.option.disk.disk_size_old':
            this.display_order_info.neo.option.disk.disk_size_old = this.order_info.neo.option.disk.disk_size_old
            break
          // Sync for smartphoneの場合
          case 'neo.option.sync':
            this.display_order_info.neo.option.sync.user = this.order_info.neo.option.sync.user
            break
          // desknet'sドライブ ディスク増設の場合
          case 'neo.option.dn_drive':
            this.display_order_info.neo.option.dn_drive.disk_size = this.order_info.neo.option.dn_drive.disk_size
            break
          // BASIC認証の場合
          case 'neo.security.basic':
            this.display_order_info.neo.security.basic.basic_id = this.order_info.neo.security.basic.basic_id
            this.display_order_info.neo.security.basic.basic_password = this.order_info.neo.security.basic.basic_password
            this.display_order_info.neo.security.basic.basic_except_ip = this.order_info.neo.security.basic.basic_except_ip
            break
          // 接続元IPアドレス制限の場合
          case 'neo.security.connect_permit_ip':
            this.display_order_info.neo.security.connect_permit_ip = this.order_info.neo.security.connect_permit_ip
            break
          // クライアント認証の場合
          case 'neo.security.client':
            this.display_order_info.neo.security.client.device = this.order_info.neo.security.client.device
            this.display_order_info.neo.security.client.cert_except_ip = this.order_info.neo.security.client.cert_except_ip
            break
          // セキュアブラウザの場合
          case 'neo.security.secure':
            this.display_order_info.neo.security.secure.secure_browser_terminal = this.order_info.neo.security.secure.secure_browser_terminal
            this.display_order_info.neo.security.secure.secure_browser_device = this.order_info.neo.security.secure.secure_browser_device
            this.display_order_info.neo.security.secure.secure_except_ip = this.order_info.neo.security.secure.secure_except_ip
            this.display_order_info.neo.security.secure.secure_browser_certificate_action = this.order_info.neo.security.secure.secure_browser_certificate_action
            this.display_order_info.neo.security.secure.secure_browser_re_create = this.order_info.neo.security.secure.secure_browser_re_create
            this.display_order_info.neo.security.secure.secure_browser_delete_certificate = this.order_info.neo.security.secure.secure_browser_delete_certificate
            break
          // WebARENAの場合
          case 'neo.mail.arena':
            this.display_order_info.neo.mail.arena.account = this.order_info.neo.mail.arena.account
            this.display_order_info.neo.mail.arena.wa_domain = this.order_info.neo.mail.arena.wa_domain
            break
          // CYBERMAILΣの場合
          case 'neo.mail.cyber':
            this.display_order_info.neo.mail.cyber.account = this.order_info.neo.mail.cyber.account
            this.display_order_info.neo.mail.cyber.mailbox = this.order_info.neo.mail.cyber.mailbox
            this.display_order_info.neo.mail.cyber.options = this.order_info.neo.mail.cyber.options
            this.display_order_info.neo.mail.cyber.keep = this.order_info.neo.mail.cyber.keep
            break
          // MAILGATESΣの場合
          case 'neo.mail_security.mailgates':
            this.display_order_info.neo.mail_security.mailgates.account = this.order_info.neo.mail_security.mailgates.account
            this.display_order_info.neo.mail_security.mailgates.mailgates_domain = this.order_info.neo.mail_security.mailgates.mailgates_domain
            this.display_order_info.neo.mail_security.mailgates.options = this.order_info.neo.mail_security.mailgates.options
            break
          // ChatLuckの場合
          case 'chat.chat_user':
            this.display_order_info.chat.chat_user = this.order_info.chat.chat_user
            break
          // ChatLuck ディスク増設の場合
          case 'chat.option.disk.disk_size':
            this.display_order_info.chat.option.disk.disk_size = this.order_info.chat.option.disk.disk_size
            break
          // ChatLuck BASIC認証の場合
          case 'chat.security.basic':
            this.display_order_info.chat.security.basic.basic_id = this.order_info.chat.security.basic.basic_id
            this.display_order_info.chat.security.basic.basic_password = this.order_info.chat.security.basic.basic_password
            this.display_order_info.chat.security.basic.basic_except_ip = this.order_info.chat.security.basic.basic_except_ip
            break
          // ChatLuck 接続元IPアドレス制限の場合
          case 'chat.security.connect_permit_ip':
            this.display_order_info.chat.security.connect_permit_ip = this.order_info.chat.security.connect_permit_ip
            break
        }
      })
    },
    /**
     * 修正ボタンを押した際の処理
     *
     * @param {string} sAnchor アンカー位置
     */
    modifyOrder(sAnchor) {
      // セッションストレージから見積枝番を削除
      sessionStorage.removeItem('estimate_branch');

      // 前ページに遷移する
      this.$router.push({
        name: 'ContractChanges',
        // 契約内容変更フラグをONにする
        params: {
          change_orders: true
        },
        // アンカー位置
        hash: '#' + sAnchor,
      })
    },
    /**
     * 定義値からプラン名を取得する
     *
     * @param {string} sPlanName プラン名
     * @return {string} プラン名の表示名
     */
    getPlanName(sPlanName) {
      // ライトプランの場合
      if (sPlanName === 'light_user') {
        return 'ライトプラン'
      }
      // スタンダードプランの場合
      if (sPlanName === 'standard_user') {
        return 'スタンダードプラン'
      }
      // プレミアムプランの場合
      if (sPlanName === 'premium_user') {
        return 'プレミアムプラン'
      }
      // チャットプラスプランの場合
      if (sPlanName === 'chatplus_user') {
        return 'チャットプラスプラン'
      }
      // desknet's NEOの場合
      if (sPlanName === 'neo.neo_user') {
        return 'ライトプラン'
      }
      // 上記以外の場合は空文字を返す
      return ''
    },
    /**
     * プランの中にAppSuite製品を含むか
     *
     * @param {string} sPlanName プラン名
     * @return {boolean} true：含む、false：含まない
     */
    isContainAppSuiteInPlan(sPlanName) {
      // スタンダード、プレミアムプランの場合は含む
      return ['standard_user', 'premium_user'].includes(sPlanName)
    },
    /**
     * プランの中にChatLuck製品を含むか
     *
     * @param {string} sPlanName プラン名
     * @return {boolean} true：含む、false：含まない
     */
    isContainChatLuckInPlan(sPlanName) {
      // プレミアム、チャットプラスプランの場合は含む
      return ['premium_user', 'chatplus_user'].includes(sPlanName)
    },
    /**
     * 変更対象製品に対象の製品名・注文種別のデータが存在するか
     *
     * @param {string} sProductName 製品名
     * @param {string} sOrderType   注文種別
     * @return {boolean} true：含む、false：含まない
     */
    isContainTargetProduct(sProductName, sOrderType) {
      // 対象の変更対象製品が存在するか確認する
      return this.common_info.target_product.filter(product => product.name === sProductName && product.order_type === sOrderType).length > 0
    },
    /**
     * 新規注文かどうか
     *
     * @param {string} sProductName 製品名
     * @return {boolean} true：新規注文、false：新規注文以外
     */
    isNewOrder(sProductName) {
      // 変更対象製品に新規注文のデータが存在するか確認する
      return this.isContainTargetProduct(sProductName, '0')
    },
    /**
     * 変更注文かどうか
     *
     * @param {string} sProductName 製品名
     * @return {boolean} true：変更注文、false：変更注文以外
     */
    isChangeOrder(sProductName) {
      // 変更対象製品に変更注文のデータが存在するか確認する
      return this.isContainTargetProduct(sProductName, '1')
    },
    /**
     * 解約注文かどうか
     *
     * @param {string} sProductName 製品名
     * @return {boolean} true：解約注文、false：解約注文以外
     */
    isCancelOrder(sProductName) {
      // 変更対象製品に解約注文のデータが存在するか確認する
      return this.isContainTargetProduct(sProductName, '2')
    },
    /**
     * ユーザー数の差分を取得する
     *
     * @param {string} sProductName 製品名
     * @return {int} ユーザー数の差分
     */
    getDiffUser(sProductName) {
      // ライトプランの場合
      if (sProductName === 'light_user') {
        return this.display_order_info[sProductName] - this.contract_info[sProductName]
      }
      // スタンダードプランの場合
      if (sProductName === 'standard_user') {
        return this.display_order_info[sProductName] - this.contract_info[sProductName]
      }
      // プレミアムプランの場合
      if (sProductName === 'premium_user') {
        return this.display_order_info[sProductName] - this.contract_info[sProductName]
      }
      // チャットプラスプランの場合
      if (sProductName === 'chatplus_user') {
        return this.display_order_info[sProductName] - this.contract_info[sProductName]
      }
      // desknet's NEOの場合
      if (sProductName === 'neo.neo_user') {
        return this.display_order_info.neo.neo_user - this.contract_info.neo.neo_user
      }
      // AppSuiteの場合
      if (sProductName === 'neo.app_suite_user') {
        return this.display_order_info.neo.app_suite_user - this.contract_info.neo.app_suite_user
      }
      // 旧AppSuiteの場合
      if (sProductName === 'neo.app_suite_user_old') {
        return this.display_order_info.neo.app_suite_user_old - this.contract_info.neo.app_suite_user_old
      }
      // ウェブ会議の売
      if (sProductName === 'neo.web_conferencing') {
        return this.display_order_info.neo.web_conferencing - this.contract_info.neo.web_conferencing
      }
      // タイムカード + CLOUZAの場合
      if (sProductName === 'neo.option.clouza') {
        return this.display_order_info.neo.option.clouza.user - this.contract_info.neo.option.clouza.user
      }
      // ディスク増設の場合
      if (sProductName === 'neo.option.disk.disk_size') {
        return this.display_order_info.neo.option.disk.disk_size - this.contract_info.neo.option.disk.disk_size
      }
      // 旧ディスク増設の場合
      if (sProductName === 'neo.option.disk.disk_size_old') {
        return this.display_order_info.neo.option.disk.disk_size_old - this.contract_info.neo.option.disk.disk_size_old
      }
      // Sync for smartphone
      if (sProductName === 'neo.option.sync') {
        return this.display_order_info.neo.option.sync.user - this.contract_info.neo.option.sync.user
      }
      // desknet'sドライブ ディスク増設の場合
      if (sProductName === 'neo.option.dn_drive') {
        return this.display_order_info.neo.option.dn_drive.disk_size - this.contract_info.neo.option.dn_drive.disk_size
      }
      // クライアント認証の場合
      if (sProductName === 'neo.security.client') {
        return this.display_order_info.neo.security.client.device - this.contract_info.neo.security.client.device
      }
      // セキュアブラウザ
      if (sProductName === 'neo.security.secure') {
        return this.display_order_info.neo.security.secure.secure_browser_device - this.contract_info.neo.security.secure.secure_browser_device
      }
      // Web ARENA
      if (sProductName === 'neo.mail.arena') {
        return this.display_order_info.neo.mail.arena.account - this.contract_info.neo.mail.arena.account
      }
      // CYBERMAILΣ
      if (sProductName === 'neo.mail.cyber') {
        return this.display_order_info.neo.mail.cyber.account - this.contract_info.neo.mail.cyber.account
      }
      // MAILGATESΣ
      if (sProductName === 'neo.mail_security.mailgates') {
        return this.display_order_info.neo.mail_security.mailgates.account - this.contract_info.neo.mail_security.mailgates.account
      }
      // ChatLuck
      if (sProductName === 'chat.chat_user') {
        return this.display_order_info.chat.chat_user - this.contract_info.chat.chat_user
      }
      // ChatLuckディスク増設の場合
      if (sProductName === 'chat.option.disk.disk_size') {
        return this.display_order_info.chat.option.disk.disk_size - this.contract_info.chat.option.disk.disk_size
      }

      // 上記以外の場合0を返す
      return 0
    },
    /**
     * 注文を持っているかどうか
     *
     * @param {string} sProductName 製品名
     * @return {boolean} true: 持っている、false: 持っていない
     */
    hasOrder(sProductName) {
      // 製品名によって注文のどこを見るか決める
      switch(sProductName) {
        // AppSuiteの場合
        case 'neo.app_suite_user':
          // AppSuiteのユーザー数を対象とする
          return this.display_order_info.neo.app_suite_user !== ''
        // 旧AppSuiteの場合
        case 'neo.app_suite_user_old':
          // 旧AppSuiteのユーザー数を対象とする
          return this.display_order_info.neo.app_suite_user_old !== ''
        // ウェブ会議の場合
        case 'neo.web_conferencing':
          // ウェブ会議の会議室数を対象とする
          return this.display_order_info.neo.web_conferencing !== ''
        // desknet's DBの場合
        case 'neo.cloud_db_user':
          // desknet's DBのユーザー数を対象とする
          return this.display_order_info.neo.cloud_db_user !== ''
        // RoomMgrの場合
        case 'neo.option.room_mgr':
          // RoomMgrのフラグを対象とする
          return this.display_order_info.neo.option.room_mgr !== false
        // 交通費・経費精算の場合
        case 'neo.option.expense_settlement':
          // 交通費・経費精算のフラグを対象とする
          return this.display_order_info.neo.option.expense_settlement !== false
        // CLOUZAの場合
        case 'neo.option.clouza':
          // CLOUZAのユーザー数を対象とする
          return this.display_order_info.neo.option.clouza.user !== ''
        // ディスク増設の場合
        case 'neo.option.disk.disk_size':
          // ディスク増設の数量を対象とする
          return this.display_order_info.neo.option.disk.disk_size !== ''
        // 旧ディスク増設の場合
        case 'neo.option.disk.disk_size_old':
          // 旧ディスク増設の数量を対象とする
          return this.display_order_info.neo.option.disk.disk_size_old !== ''
        // Sync for Smartphoneの場合
        case 'neo.option.sync':
          // Sync for Smartphoneのユーザー数を対象とする
          return this.display_order_info.neo.option.sync.user !== ''
        // desknet'sドライブ ディスク増設の場合
        case 'neo.option.dn_drive':
          // desknet'sドライブのディスク増設を対象とする
          return this.display_order_info.neo.option.dn_drive.disk_size !== ''
        // BASIC認証の場合
        case 'neo.security.basic':
          // BASIC IDを対象とする
          return this.display_order_info.neo.security.basic.basic_id !== ''
        // 接続許可IPアドレスの場合
        case 'neo.security.connect_permit_ip':
          // 接続許可IPアドレスを対象する
          return this.display_order_info.neo.security.connect_permit_ip !== ''
        // クライアント認証の場合
          case 'neo.security.client':
            // クライアント認証のデバイス数を対象とする
            return this.display_order_info.neo.security.client.device !== ''
        // セキュアブラウザの場合
        case 'neo.security.secure':
          // セキュアブラウザ端末認証フラグを対象とする
          return this.display_order_info.neo.security.secure.secure_browser_terminal !== ''
        // Web ARENAの場合
        case 'neo.mail.arena':
          // Web ARENAのアカウント数を対象とする
          return this.display_order_info.neo.mail.arena.account !== ''
        // CYBERMAILΣの場合
        case 'neo.mail.cyber':
          // CYBERMAILΣのアカウント数を対象とする
          return this.display_order_info.neo.mail.cyber.account !== ''
        // MAILGATESΣの場合
        case 'neo.mail_security.mailgates':
          // MAILGATESΣのアカウント数を対象とする
          return this.display_order_info.neo.mail_security.mailgates.account !== ''
        // ChatLuckの場合
        case 'chat.chat_user':
          // ChatLuckユーザー数を対象とする
          return this.display_order_info.chat.chat_user !== ''
        // ChatLuckディスク増設の場合
        case 'chat.option.disk.disk_size':
          // ChatLuckディスク増設の数量を対象とする
          return this.display_order_info.chat.option.disk.disk_size !== ''
        // ChatLuckBASIC認証の場合
        case 'chat.security.basic':
          // ChatLuckBASIC IDを対象とする
          return this.display_order_info.chat.security.basic.basic_id !== ''
        // ChatLuck接続元IPアドレス制限の場合
        case 'chat.security.connect_permit_ip':
          // 接続許可IPアドレスを対象とする
          return this.display_order_info.chat.security.connect_permit_ip !== ''
      }

      // 上記以外の場合は注文なし
      return false
    },
    /**
     * desknet's NEOのオプションが注文にあるか
     *
     * @return {boolean} true：オプションを持っている、false：オプションを持っていない
     */
    hasNeoOption() {
      // AppSuiteが注文情報に存在する場合
      if (this.hasOrder('neo.app_suite_user') === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // 旧AppSuiteが注文情報に存在する場合
      if (this.hasOrder('neo.app_suite_user_old') === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // ウェブ会議が注文情報に存在する場合
      if (this.hasOrder('neo.web_conferencing') === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // desknet's DBが注文情報に存在する場合
      if (this.hasOrder('neo.cloud_db_user') === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // desknet's NEOオプションサービスが注文情報に存在する場合
      if (this.hasNeoOptionService() === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // desknet's NEOセキュリティオプションが注文情報に存在する場合
      if (this.hasNeoSecurityOption() === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // desknet's NEOメールサービスが注文情報に存在する場合
      if (this.hasNeoMailService() === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // desknet's NEOメールサービスが注文情報に存在する場合
      if (this.hasNeoMailSecurityService() === true) {
        // desknet's NEOのオプションを持っているとする
        return true
      }
      // 上記以外の場合
      // desknet's NEOのオプションが注文にないとする
      return false
    },
    /**
     * desknet's NEOオプションサービスの注文があるか
     *
     * @return {boolean} true：オプションサービスの注文がある、false：オプションサービスの注文がない
     */
    hasNeoOptionService() {
      // RoomMgrが注文にある場合
      if (this.hasOrder('neo.option.room_mgr') === true) {
        // desknet's NEOオプションサービスの注文があるとする
        return true
      }
      // 交通費・経費精算が注文にある場合
      if (this.hasOrder('neo.option.expense_settlement') === true) {
        // desknet's NEOオプションサービスの注文があるとする
        return true
      }
      // CLOUZAが注文にある場合
      if (this.hasOrder('neo.option.clouza') === true) {
        // desknet's NEOオプションサービスの注文があるとする
        return true
      }
      // ディスク増設が注文にある場合
      if (this.hasOrder('neo.option.disk.disk_size') === true) {
        // desknet's NEOオプションサービスの注文があるとする
        return true
      }
      // 旧ディスク増設が注文にある場合
      if (this.hasOrder('neo.option.disk.disk_size_old') === true) {
        // desknet's NEOオプションサービスの注文があるとする
        return true
      }
      // Sync for smartphoneが注文にある場合
      if (this.hasOrder('neo.option.sync') === true) {
        // desknet's NEOオプションサービスの注文があるとする
        return true
      }
      // desknet's ドライブが注文にある場合
      if (this.hasOrder('neo.option.dn_drive') === true) {
        // desknet's NEOオプションサービスの注文があるとする
        return true
      }

      // 上記以外の場合はdesknet'sオプションサービスの注文がないとする
      return false
    },
    /**
     * desknet's NEO セキュリティオプションの注文があるか
     *
     * @return {boolean} true：セキュリティオプションの注文がある、false：セキュリティオプションの注文がない
     */
    hasNeoSecurityOption() {
      // BASIC認証が注文にある場合
      if (this.hasOrder('neo.security.basic') === true) {
        // desknet's NEOセキュリティオプションの注文があるとする
        return true
      }
      // 接続元IPアドレス制限が注文にある場合
      if (this.hasOrder('neo.security.connect_permit_ip') === true) {
        // desknet's NEOセキュリティオプションの注文があるとする
        return true
      }
      // クライアント認証が注文にある場合
      if (this.hasOrder('neo.security.client') === true) {
        // desknet's NEOセキュリティオプションの注文があるとする
        return true
      }
      // セキュアブラウザが注文にある場合
      if (this.hasOrder('neo.security.secure') === true) {
        // desknet's NEOセキュリティオプションの注文があるとする
        return true
      }

      // 上記以外の場合は、desknet'sNEOセキュリティオプションの注文がないとする
      return false
    },
    /**
     * desknet's NEOメールサービスの注文があるか
     *
     * @return {boolean} true：desknet's NEOメールサービスの注文がある、false：desknet's NEOメールサービスの注文がない
     */
    hasNeoMailService() {
      // Web ARENAが注文にある場合
      if (this.hasOrder('neo.mail.arena') === true) {
        // desknet's NEOメールサービスの注文があるとする
        return true
      }
      // CYBERMAILΣが注文にある場合
      if (this.hasOrder('neo.mail.cyber') === true) {
        // desknet's NEOメールサービスの注文があるとする
        return true
      }

      // 上記以外の場合はdesknet's NEOメールサービスの注文がないとする
      return false
    },
    /**
     * desknet's NEOメールセキュリティサービスの注文があるか
     *
     * @return {boolean} true：desknet's NEOメールセキュリティサービスを持っている、false：desknet's NEOメールセキュリティサービスを持っていない
     */
    hasNeoMailSecurityService() {
      // MAILGATESΣが注文にある場合
      if (this.hasOrder('neo.mail_security.mailgates') === true) {
        // desknet's NEOメールセキュリティサービスの注文があるとする
        return true
      }

      // 上記以外の場合はdesknet's NEOメールセキュリティサービスの注文がないとする
      return false
    },
    /**
     * ChatLuckのオプションの注文があるか
     *
     * @return {boolean} true：ChatLuckのオプションの注文がある、false：ChatLuckのオプションの注文がない
     */
    hasChatOption() {
      // ChatLuckオプションサービスの注文がある場合
      if (this.hasChatOptionService() === true) {
        // ChatLuckのオプションの注文があるとする
        return true
      }
      // ChatLuckセキュリティオプションの注文がある場合
      if (this.hasChatSecurityOption() === true) {
        // ChatLuckのオプションの注文があるとする
        return true
      }

      // 上記以外の場合ChatLuckのオプションの注文がないとする
      return false
    },
    /**
     * ChatLuckオプションサービスの注文があるか
     *
     * @return {boolean} true：ChatLuckオプションサービスの注文がある、false：ChatLuckオプションサービスの注文がない
     */
    hasChatOptionService() {
      // ChatLuckディスク増設の注文がある場合
      if (this.hasOrder('chat.option.disk.disk_size') === true) {
        // ChatLuckオプションサービスの注文があるとする
        return true
      }

      // 上記以外の場合はChatLuckオプションサービスの注文がないとする
      return false
    },
    /**
     * ChatLuckセキュリティオプションの注文があるか
     *
     * @return {boolean} true：ChatLuckセキュリティオプションの注文がある、false：ChatLuckセキュリティオプションの注文がない
     */
    hasChatSecurityOption() {
      // ChatLuck BASIC認証の注文がある場合
      if (this.hasOrder('chat.security.basic') === true) {
        // ChatLuckセキュリティオプションの注文があるとする
        return true
      }
      // ChatLuck接続元IPアドレス制限の注文がある場合
      if (this.hasOrder('chat.security.connect_permit_ip') === true) {
        // ChatLuckセキュリティオプションの注文があるとする
        return true
      }

      // 上記以外の場合はChatLuckセキュリティオプションの注文がないとする
      return false
    },
    /**
     * IPアドレスを5つずつまとめる
     *
     * @param {string} $sIPAddress IPアドレス
     */
    getFormattedIPAddress(sIPAddress) {
      // IPアドレスがundefinedの場合は空配列を返す
      if (typeof sIPAddress === 'undefined') {
        return []
      }
      // IPアドレスがnullの場合は空配列を返す
      if (sIPAddress === null) {
        return []
      }
      // IPアドレスを5つずつ改行区切りでまとめる
      return this.showItemsAsRow(sIPAddress, 5, '\n')
    },
    /**
     * ディスク増設の表示文字列を取得する
     *
     * @param {string} sDiskSize ディスク容量
     */
    getDisplayDiskSize(sDiskSize) {
      // 数値の場合
      if (/^\d+$/.test(sDiskSize)) {
        // 20GB × {取得したディスク容量} = {20 × 取得したディスク容量}GBを返す
        return '20GB × ' + sDiskSize + ' = ' + (20 * parseInt(sDiskSize)) + 'GB'
      }

      // 上記以外の場合は空文字を返す
      return ''
    },
    /**
     * desknet'sドライブ ディスク増設の表示文字列を取得する
     *
     * @param {string} sDiskSize desknet'sドライブ ディスク容量
     */
    getDisplayDndriveDiskSize(sDiskSize) {
      // 数値の場合
      if (/^\d+$/.test(sDiskSize)) {
        // 20GB × {取得したdesknet'sドライブ ディスク容量} = {20 × 取得したdesknet'sドライブ ディスク容量}GBを返す
        return '20GB × ' + sDiskSize + ' = ' + (20 * parseInt(sDiskSize)) + 'GB'
      }

      // 上記以外の場合は空文字を返す
      return ''
    },
    /**
     * CYBERMAILΣのオプションを持っているか
     *
     * @param {string} sOption オプション
     * @return {boolean} true：持っている、false：持っていない
     */
    hasCyberOption(sOption) {
      // CYBERMAILΣの注文がある場合
      if (this.hasOrder('neo.mail.cyber') === true) {
        // 対象のオプションを持っているか確認する
        return this.display_order_info.neo.mail.cyber.options.includes(sOption)
      }
      // 上記以外の場合はfalseを返す
      return false
    },
    /**
     * MAILGATESΣのオプションを持っているか
     *
     * @param {string} sOption オプション
     * @return {boolean} true：持っている、false：持っていない
     */
    hasMailgatesOption(sOption) {
      // MAILGATESΣの注文がある場合
      if (this.hasOrder('neo.mail_security.mailgates') === true) {
        // 対象のオプションを持っているか確認する
        return this.display_order_info.neo.mail_security.mailgates.options.includes(sOption)
      }
      // 上記以外の場合はfalseを返す
      return false
    },
    /**
     * 見積書を作成するボタンを押した際の処理
     *
     * @return {void}
     */
    createQuotation() {
      // ローディングフラグをONにする
      this.is_loading = true

      // エラーメッセージを初期化
      this.order_errors = []
      this.quotation_errors = []

      // リクエストパラメータを作成する
      let params = {
        // 契約番号
        contract_no: Number(this.common_info.contract_no),
        // 見積書種類
        quote_kind: {
          total: this.total_quotation_flg,
          individual: this.individual_quotation_flg,
        },
        // 注文情報
        data: this.order_info,
        // 変更対象製品
        target_product: this.common_info.target_product,
        // 変更希望日
        opening_date: this.common_info.opening_date,
        // 見積番号
        estimate_no: this.common_info.estimate_no,
        // 備考
        order_remarks: this.common_info.order_remarks,
      }

      // S21402_見積書作成処理を実行する
      S214Quotation.create(params)
        // 処理に成功した場合
        .then(() => {
          // 見積書一覧へ遷移する
          this.$router.push({
            name: 'QuotationList',
          })
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, '見積書作成処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          this.quotation_errors = this.errors
        })
        .finally(() => {
          // ローディングを終了する
          this.is_loading = false
        })
    },
    /**
     * 申込むボタンを押した際の処理
     */
    applyOrder() {
      // ローディングフラグをONにする
      this.is_loading = true

      // エラーメッセージを初期化
      this.order_errors = []
      this.quotation_errors = []

      // リクエストパラメータを作成する
      let params = {
        // 契約番号
        contract_no: Number(this.common_info.contract_no),
        // 注文情報
        data: this.order_info,
        // 変更対象製品
        target_product: this.common_info.target_product,
        // 変更希望日
        opening_date: this.common_info.opening_date,
        // 見積番号
        estimate_no: this.common_info.estimate_no,
        // 備考
        order_remarks: this.common_info.order_remarks,
      }

      // 見積枝番がnull・空文字以外の場合
      if (this.estimate_branch !== null && this.estimate_branch !== '') {
        // リクエストパラメータに見積枝番を追加する
        params['estimate_branch'] = this.estimate_branch
      }

      // S21402_見積書作成処理を実行する
      S213ContractChanges.add(params)
        // 処理に成功した場合
        .then(() => {
          // ご注文履歴画面へ遷移する
          this.$router.push({
            name: 'OrderHistory'
          })
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, '変更内容更新処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          this.order_errors = this.errors
          // 画面一番上へスクロールをする
          this.pageTopScroll()
        })
        .finally(() => {
          // ローディングを終了する
          this.is_loading = false
        })
    },
    /**
     * 申請内容を修正するボタンを押した際の処理
     */
    moveInputPage() {
      // セッションストレージから見積枝番を削除
      sessionStorage.removeItem('estimate_branch');

      // 変更内容入力画面に遷移する
      this.$router.push({
        name: 'ContractChanges',
        params: {
          change_orders: true
        }
      })
    }
  }
}
</script>

<style scoped>
.next-icon {
  margin-top: 2px;
}
.message-border-style {
  border-width: 2px !important;
}
.neo-title-bg-color {
  background-color: #f2ffff;
}
.chat-title-bg-color {
  background-color: #f0ffe0;
}
.plan-title-bg-color {
  background-color: #fceaee;
}
.other-title-bg-color {
  background-color: #f5f5f5;
}
.border-color-plan {
  border-color: #eb6ea0!important;
}
.border-color-other {
  border-color: grey!important;
}
.label-font-size {
  font-size: 16px;
}
.anchor-button {
  height: 22px;
  vertical-align: center;
  text-align: center;
  margin-top: -2px;
  padding-top: 0;
}
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.logo_appsuite {
  width:100px;
  height: auto;
}

.new-label-before:before {
  content: "新規";
  background-color: orange;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  min-width: 90px;
  padding: 6px;
  margin: 0px 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}
.change-label-before:before {
  content: "変更";
  background-color: blueviolet;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  min-width: 90px;
  padding: 6px;
  margin: 0px 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}
.cancel-label-before:before {
  content: "解約";
  background-color: red;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  min-width: 90px;
  padding: 6px;
  margin: 0px 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}
.none-label-before:before {
  content: "";
  background-color: rgba(0, 0, 0, 0);
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  margin: 0px 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}
.checkbox-description {
  font-size: 1rem;
}
.white-space {
  white-space: pre-wrap;
}
</style>
